const ru = {
  "swap-crypto-sans-frais": {
    title: "Крипто-своп без дополнительных комиссий: чего Lumina не добавляет и из чего реально складывается стоимость",
    meta: "Lumina не добавляет собственных дополнительных сервисных комиссий к вашему свопу. Узнайте о шести компонентах, которые реально формируют стоимость свопа: коммерческая комиссия, выплачиваемая партнёром Lumina, маржа партнёра, комиссии сети, спред, проскальзывание и влияние на цену.",
    body: `Иногда вы видите выражение "крипто-своп без комиссий". Эта формулировка может ввести в заблуждение: она описывает отсутствие дополнительных сервисных комиссий, добавленных кошельком, а не отсутствие каких-либо затрат. Крипто-своп остаётся рыночной операцией с несколькими компонентами затрат, независимыми от Lumina.

## Однозначное резюме

Lumina не добавляет собственных дополнительных сервисных комиссий к вашему свопу. Lumina может получать коммерческое вознаграждение от партнёра по обмену. Котировка может включать тарифные условия партнёра, спред, проскальзывание, влияние на цену и комиссии сети. Курс и предполагаемая сумма к получению отображаются до вашего подтверждения.

## Шесть компонентов стоимости свопа

Чтобы понять, что вы реально платите, нужно различать шесть элементов:

### 1. Сервисные комиссии, добавленные Lumina

Lumina **не добавляет** дополнительных сервисных комиссий поверх котировки, предоставленной партнёром по обмену. Отображаемая вам сумма уже отражает это отсутствие наценки.

### 2. Коммерческая комиссия, получаемая Lumina

Lumina может получать коммерческое вознаграждение от партнёра по обмену. Lumina не добавляет эту сумму к котировке отдельной строкой комиссии; однако она может быть учтена в тарифных условиях, предлагаемых партнёром.

### 3. Комиссии или маржа партнёра по обмену

Партнёр по обмену может применять собственные операционные комиссии и собственную маржу. Эти элементы включаются в курс и предполагаемую сумму, отображаемые в котировке до вашего подтверждения.

### 4. Комиссии сети (gas fees)

Комиссии сети вознаграждают майнеров или валидаторов, обрабатывающих транзакцию. Они варьируются в зависимости от блокчейна и его загруженности. В зависимости от используемого потока свопа они могут быть оценены, объединены или представлены в котировке партнёра.

### 5. Спред

Спред — это разница между ценой покупки и ценой продажи, отображаемой источником ликвидности. Это неявная стоимость: вы не видите её как строку комиссии, но она напрямую влияет на курс, применяемый к вашему свопу.

### 6. Проскальзывание и влияние на цену

- **Проскальзывание** — это разница между курсом, оценённым в момент котировки, и курсом, фактически полученным при исполнении. Оно растёт, когда доступная ликвидность снижается.
- **Влияние на цену** — это эффект, который ваш собственный ордер оказывает на цену: чем больше ваша сумма относительно ликвидности, тем хуже цена для вас.

Эти два элемента могут изменить окончательную сумму, которую вы получите, по сравнению с первоначальной оценкой.

## Что Lumina отображает перед вашим подтверждением

Перед вашим подтверждением Lumina отображает предполагаемый курс и сумму, сообщённые партнёром, а также тарифную информацию, доступную в котировке. Комиссии сети отображаются, когда они указаны или оценены соответствующим потоком свопа.

Вы сохраняете окончательное решение: после ознакомления с котировкой вы выбираете подтвердить или отменить операцию.

## Как сделать своп в Lumina Wallet

1. Откройте вкладку **Swap** в приложении.
2. Выберите токен, который хотите обменять, и токен для получения.
3. Введите сумму для обмена.
4. Ознакомьтесь с отображаемой котировкой: предполагаемый курс и сумма, а также доступная тарифная информация (включая комиссии сети, когда они указаны или оценены).
5. Если котировка вас устраивает, подтвердите транзакцию. В противном случае отмените и скорректируйте.

## Запомнить

Крипто-своп никогда не бывает полностью бесплатным, даже когда сам кошелёк не добавляет сервисных комиссий. Реальная стоимость зависит от партнёра, сети, спреда, проскальзывания и влияния на цену. Хорошая практика заключается в изучении котировки, сравнении при необходимости и проверке каждого параметра перед подтверждением.

**Готовы попробовать?** [Скачайте Lumina Wallet](/ru/download) и совершите свой первый своп, сохраняя контроль на каждом шаге.`
  },
  "comment-eviter-arnaques-crypto": {
    title: "Как избежать крипто-мошенничества в 2026: Полное руководство",
    meta: "Узнайте о самых распространённых крипто-мошенничествах 2026 года (фишинг, rug pull, фальшивые аирдропы) и научитесь их избегать. Полное руководство по защите вашего кошелька.",
    body: `Мир криптовалют увлекателен, но привлекает и множество мошенников. В 2025 году крипто-мошенничества достигли беспрецедентного уровня сложности, нанеся инвесторам убытки на миллиарды долларов [1]. Понимание этих угроз — первый шаг к защите ваших цифровых активов.

## Самые распространённые виды крипто-мошенничества в 2026

### 1. Фишинг

Фишинг остаётся самым распространённым методом. Мошенники создают поддельные сайты, имитирующие легитимные платформы, чтобы заставить вас ввести вашу фразу восстановления (seed phrase) или подключить кошелёк.

> **Пример**: Вы получаете email якобы от MetaMask с просьбой верифицировать аккаунт по ссылке. Ссылка ведёт на сайт-клон, который записывает ваши данные.

**Как избежать**:
- Никогда не переходите по ссылкам из незапрошенных сообщений.
- Всегда проверяйте URL сайта.
- **НИКОГДА** не вводите фразу восстановления на сайте.

### 2. Rug Pull

«Rug pull» происходит, когда команда разработчиков запускает токен, привлекает инвесторов, а затем внезапно выводит всю ликвидность проекта.

**Как избежать**:
- **Исследуйте команду**: Анонимная команда — серьёзный предупреждающий сигнал.
- **Проверьте ликвидность**: Заблокирована ли она?
- **Анализируйте распределение токенов**: Если несколько адресов держат большую долю — риск высок.

### 3. Фальшивые аирдропы и розыгрыши

Мошенники обещают бесплатные токены в обмен на «транзакционный сбор» или подключение кошелька к вредоносному сайту.

**Как избежать**:
- Настоящие аирдропы **никогда** не просят отправлять деньги.
- Будьте осторожны с нереалистичными обещаниями.
- Всегда проверяйте информацию на официальных каналах проекта.

### 4. Мошенничество с одобрением смарт-контрактов (Approve/Permit)

Вы подписываете транзакцию, дающую вредоносному смарт-контракту разрешение тратить токены из вашего кошелька.

## Как Lumina Wallet защищает вас

| Функция безопасности | Как Lumina вас защищает |
|---|---|
| **Антимошеннический сканер в реальном времени** | Анализирует адреса и смарт-контракты для обнаружения угроз. |
| **Симуляция транзакции** | Показывает, что произойдёт, **до** подписания. |
| **Самостоятельное хранение (Non-Custodial)** | Ваши приватные ключи никогда не покидают устройство. |

## Заключение

Используя безопасный кошелёк **Lumina Wallet**, вы добавляете важный слой технологической защиты.

**Готовы защитить свои криптоактивы?** [Скачайте Lumina Wallet сегодня](#) и торгуйте с уверенностью.

---

### Источники

[1] Chainalysis. (2026). *2026 Crypto Crime Report: Scams*. [https://www.chainalysis.com/blog/crypto-scams-2026/](https://www.chainalysis.com/blog/crypto-scams-2026/)`
  },
  "securiser-wallet-crypto": {
    title: "Как защитить свой крипто-кошелёк: 10 важных шагов",
    meta: "Узнайте, как защитить крипто-кошелёк. Защитите фразу восстановления, используйте non-custodial кошелёк и включите 2FA.",
    body: `Безопасность ваших криптовалют зависит не только от платформы, но и от ваших привычек.

## 1. Выберите Non-Custodial кошелёк

**Non-custodial** кошелёк, как **Lumina Wallet**, означает, что только вы владеете приватными ключами.

> **«Not your keys, not your coins»** — главная мантра.

## 2. Защитите фразу восстановления

- **Запишите на бумаге**: Не храните на подключённых к интернету устройствах.
- **Сделайте несколько копий**: В разных безопасных местах.
- **НИКОГДА не делитесь**.

## 3. Используйте сильный уникальный пароль

## 4. Включите двухфакторную аутентификацию (2FA)

## 5. Остерегайтесь публичного Wi-Fi

## 6. Разделите средства: «горячий» и «холодный» кошельки

| Тип кошелька | Использование | Пример |
|---|---|---|
| **Горячий (Hot Wallet)** | Ежедневные транзакции, свопы. | **Lumina Wallet** (мобильный/веб) |
| **Холодный (Cold Wallet)** | Долгосрочное хранение. | Аппаратный кошелёк (Ledger, Trezor) |

## 7. Обновляйте приложение

## 8. Будьте скептичны к dApp и новым проектам

**Lumina Wallet** помогает, симулируя транзакции.

## 9. Отзывайте разрешения

Используйте [Revoke.cash](https://revoke.cash/) для проверки и отзыва разрешений.

## 10. Используйте кошелёк с встроенной безопасностью

**Lumina Wallet**: сканер, симуляция, мультичейн.

## Заключение

Следуя этим 10 шагам с **Lumina Wallet**, вы значительно снизите риски.

**Готовы к следующему уровню безопасности?** [Скачайте Lumina Wallet](#) и возьмите полный контроль.`
  },
  "wallet-non-custodial-guide": {
    title: "Что такое Non-Custodial кошелёк? Полное руководство",
    meta: "Узнайте разницу между кастодиальным и non-custodial (самостоятельное хранение) кошельками. Почему Lumina Wallet необходим для безопасности ваших криптовалют.",
    body: `Если вы новичок в мире криптовалют, вы наверняка слышали термины «custodial» и «non-custodial».

## Custodial vs. Non-Custodial: Ключевое различие

| Тип кошелька | Кто контролирует приватные ключи? | Примеры |
|---|---|---|
| **Custodial** | Платформа (третья сторона) | Биржи (Binance, Coinbase) |
| **Non-Custodial** | **Вы** | **Lumina Wallet**, MetaMask, Ledger |

### Custodial: Простота ценой контроля

Если биржа будет взломана — вы потеряете всё. **«Not your keys, not your coins.»**

### Non-Custodial: Полный контроль и истинное владение

**Lumina Wallet** даёт полный контроль через **фразу восстановления** из 12 или 24 слов.

**Преимущества:**
- **Полный контроль**: Вы — свой собственный банк.
- **Максимальная безопасность**: Нет риска взлома платформы.
- **Конфиденциальность**: KYC не требуется.

## Lumina Wallet: Лучшее из двух миров

- **100% Non-Custodial**
- **Интуитивный интерфейс**
- **Мультичейн**: Все активы в одном приложении.

**Готовы стать своим банком?** [Скачайте Lumina Wallet](#) и откройте для себя настоящее владение криптой.`
  },
  "comparatif-wallets-crypto": {
    title: "Сравнение лучших крипто-кошельков 2026",
    meta: "Какой крипто-кошелёк лучший в 2026? Полное сравнение: Lumina Wallet, MetaMask, Trust Wallet и аппаратные кошельки (Ledger, Trezor).",
    body: `Выбор правильного крипто-кошелька критически важен. Это сравнение анализирует самые популярные кошельки 2026 года.

## Сравнение: Lumina vs. MetaMask vs. Trust Wallet vs. Ledger

| Функция | Lumina Wallet | MetaMask | Trust Wallet | Ledger |
| --- | --- | --- | --- | --- |
| **Тип** | Non-Custodial | Non-Custodial | Non-Custodial | Non-Custodial (Холодный) |
| **Безопасность** | Очень высокая (Антимошеннический сканер) | Высокая | Высокая | Максимальная |
| **Мультичейн** | BTC, ETH, SOL, XRP +10 | Сети EVM, Solana и Bitcoin | Хорошо | Хорошо |
| **Простота** | Создан для новичков | Более технический для новичков | Просто | Средне |
| **Своп** | Да (без дополнительных сервисных комиссий Lumina; могут применяться цены партнёра, сетевые комиссии, спред, проскальзывание и влияние на цену) | Да (0,875%) | Да | Да (с комиссией) |
| **NFT** | Да (Мультичейн) | Да (EVM) | Да | Да |

## Заключение

- Для **ежедневного использования**: **Lumina Wallet**
- Для **долгосрочного хранения**: **Аппаратный кошелёк**
- Для **DeFi экспертов**: **MetaMask**

**Готовы выбрать?** [Скачайте Lumina Wallet](#) и откройте новый опыт в крипте.`
  },
  "guide-debutant-crypto": {
    title: "Руководство для начинающих: Как начать в крипте в 2026",
    meta: "Хотите начать в крипте, но не знаете с чего? Этот простой гид объяснит всё: покупка первых криптовалют, выбор безопасного кошелька и первые транзакции.",
    body: `Мир криптовалют может показаться пугающим. Однако начать проще, чем кажется.

## Шаг 1: Понять основы

- **Блокчейн**: Публичный, децентрализованный цифровой реестр.
- **Криптовалюта**: Цифровой актив с криптографической защитой. Самые известные: Bitcoin (BTC) и Ethereum (ETH).
- **Кошелёк (Wallet)**: Приложение для хранения, отправки и получения криптовалют.

## Шаг 2: Купить первые криптовалюты

Через **централизованную биржу (CEX)**: Coinbase, Binance или Kraken.

1. **Создайте аккаунт**.
2. **Пройдите верификацию** (KYC).
3. **Пополните счёт**.
4. **Купите криптовалюту** по выбору.

## Шаг 3: Защитить крипту в Non-Custodial кошельке

**Обязательно переведите** крипту в кошелёк, который вы полностью контролируете, например **Lumina Wallet**.

1. **Скачайте Lumina Wallet**.
2. **Создайте новый кошелёк**. Приложение сгенерирует **фразу восстановления**.
3. **Запишите фразу на бумаге** и храните в безопасном месте.
4. **Переведите крипту** на новый адрес Lumina Wallet.

## Шаг 4: Первые транзакции

- **Отправлять и получать**: По адресу кошелька.
- **Своп**: Обменивать криптовалюты прямо в Lumina Wallet без дополнительных сервисных комиссий Lumina (сетевые комиссии и условия партнёра сохраняются).
- **dApps**: Подключайтесь через WalletConnect.

## Советы для новичков

- **Инвестируйте только то, что готовы потерять**.
- **Проводите собственное исследование (DYOR)**.
- **Будьте терпеливы**.
- **Безопасность прежде всего**.

**Готовы сделать первый шаг?** [Скачайте Lumina Wallet](#) и присоединяйтесь к революции децентрализованных финансов.`
  },
  "seed-phrase-guide": {
    title: "Что такое фраза восстановления (Seed Phrase)?",
    meta: "Ваша фраза восстановления (seed phrase) — ключ к крипто-кошельку. Узнайте, что это, как работает и как безопасно хранить.",
    body: `В мире non-custodial кошельков **фраза восстановления** — самый важный концепт безопасности.

## Что такое фраза восстановления?

Список из **12-24 слов**, генерируемый при создании non-custodial кошелька, например **Lumina Wallet**.

> **Пример**: \`witch collapse practice feed shame open despair creator tenant camp strike\`

## Как она работает?

На основе криптографического стандарта **BIP-39**:

1. Кошелёк генерирует случайную последовательность чисел.
2. Преобразует в список слов из словаря в 2048 слов.
3. Выводит **мастер-ключ**.
4. Из него генерирует **индивидуальные приватные ключи** для каждой криптовалюты.

## Почему это так важно?

- **При потере устройства**: Установите Lumina Wallet заново, введите фразу — доступ восстановлен.
- **Если фразу узнает кто-то другой**: Может украсть весь кошелёк.

> **Золотое правило**: Относитесь к фразе как к золотому слитку.

## Как безопасно хранить

### Что ДЕЛАТЬ
- **Записать на бумаге**.
- **Сделать несколько копий** в разных безопасных местах.
- **Использовать прочные материалы**: Гравировка на металлической пластине.

### Чего НЕ ДЕЛАТЬ
- **НЕ хранить на цифровых устройствах**.
- **НЕ хранить в облаке**.
- **НИКОГДА не делиться**.

**Готовы взять контроль?** [Скачайте Lumina Wallet](#) и откройте для себя силу самостоятельного хранения.`
  },
  "arnaques-smart-contracts": {
    title: "Смарт-контракты: Как избежать мошенничества с одобрениями (Approve / Permit)",
    meta: "Мошенничество со смарт-контрактами (Approve, Permit) всё чаще. Узнайте, как хакеры опустошают кошельки и как сканер Lumina Wallet может вас защитить.",
    body: `Думаете, что в безопасности, потому что никогда не делитесь фразой восстановления? Подумайте ещё раз. Новое поколение мошенничеств нацелено на взаимодействие со **смарт-контрактами**.

## Одобрение токенов (Approve)

**Что такое одобрение?** Разрешение смарт-контракту тратить определённое количество ваших токенов.

### Опасность безлимитных одобрений

Многие dApp запрашивают **безлимитные одобрения** — вы разрешаете тратить бесконечное количество ваших токенов навсегда.

## Мошенничество с «Permit» и офф-чейн подписями

1. Вредоносный сайт просит подписать сообщение (**без gas fees**).
2. Сообщение содержит авторизацию \`Permit\`.
3. Хакер использует подпись для опустошения ваших токенов.

> **Ловушка**: Нет gas fees = кажется безопасным. Это не так.

## Как Lumina Wallet революционизирует безопасность

| Обычный кошелёк | Lumina Wallet |
| --- | --- |
| Непонятные шестнадцатеричные данные | **ВНИМАНИЕ: Вы разрешаете потратить ВСЕ ваши USDC.** |
| «Подписать сообщение» | **ОСТОРОЖНО: Это сообщение авторизует перевод ваших NFT.** |

## Лучшие практики

1. **Используйте кошелёк с симуляцией транзакций** — **Lumina Wallet**.
2. **Будьте крайне подозрительны** к слишком хорошим предложениям.
3. **Используйте одноразовый кошелёк** для неизвестных dApp.
4. **Регулярно отзывайте разрешения** через [Revoke.cash](https://revoke.cash/).

**Не подписывайте вслепую.** [Скачайте Lumina Wallet](#) и узнайте, что значит настоящая безопасность транзакций.`
  },
  "arnaque-smart-contract-trust-wallet-vs-lumina": {
    title: "Мошенничество со смарт-контрактами: Почему ваш кошелёк — решето (и как Lumina защищает вас)",
    meta: "Узнайте через шокирующее сравнение, как мошенничество с безлимитным одобрением смарт-контракта может опустошить ваш кошелёк.",
    body: `> **Контекст:** 13 марта 2026 года [Le Parisien сообщило](https://www.leparisien.fr/faits-divers/arnaque-aux-cryptos-a-paris-les-escrocs-presumes-auraient-depouille-leurs-victimes-de-11-millions-deuros-13-03-2026-D53QN2HAUVFHZGX6YJBD6LKLLA.php), что сеть мошенников похитила **11 миллионов евро в криптовалюте**. Метод: мошеннические сайты и подтасованные одобрения смарт-контрактов.

---

Главный сообщник этого мошенничества? **Ваш собственный кошелёк.** Большинство кошельков показывают настолько слабые предупреждения, что обычный пользователь не понимает опасность.

## Тест: Настоящий мошеннический сайт

Мы протестировали реальный мошеннический сайт: **bitcoin-suisse-verif.com**.

## 1. Реакция Trust Wallet: Невидимая опасность

Trust Wallet показывает простое подтверждение отправки 0 ETH. Никаких предупреждений.

## 2. Реакция Lumina Wallet: Активный щит

![Предупреждение безопасности Lumina Wallet - ОПАСНОСТЬ](https://customer-assets.emergentagent.com/job_92eb487e-5db1-496a-be31-c7d8444bed8d/artifacts/9ltapzuw_screenshot_danger.png)

- **Чёткие предупреждения**: «ОПАСНОСТЬ — Безлимитный доступ» ярко-красным цветом.
- **Объяснение простым языком**.
- **Активное отговаривание**: Кнопка по умолчанию — «Отклонить».

## Прямое сравнение

| | Trust Wallet | Lumina Wallet |
|---|---|---|
| **Визуальное предупреждение** | Нет | ОПАСНОСТЬ красным |
| **Объяснение риска** | Нет | Чёткое и понятное |
| **Тип одобрения** | Не указан | «БЕЗЛИМИТНЫЙ доступ ко ВСЕМ токенам» |
| **Контракт проверен?** | Не указано | «НЕПРОВЕРЕННЫЙ контракт» |
| **Действие по умолчанию** | Одобрить | Отклонить |

> **«Одно мошенничество, два кошелька, две реакции. Один бросает вас, другой защищает.»**

**Ваша безопасность — в одном клике.** [Скачайте Lumina Wallet](#) и обретите спокойствие.`
  },
  "empoisonnement-adresse-arnaque-crypto": {
    title: "Отравление адреса (Address Poisoning): Новое криптомошенничество, которое стоит миллионы",
    meta: "Узнайте, как работает отравление адреса (address poisoning), почему простое копирование-вставка может стоить вам миллионов, и как Lumina Wallet защищает вас.",
    body: `## Невидимая угроза копирования и вставки

В стремительном мире криптовалют, где каждая транзакция на счету и требуется бдительность, распространяется новая коварная угроза: **отравление адреса**. Простое копирование и вставка, обычное ежедневное действие, теперь может стоить вам миллионы. Эта изощренная тактика киберпреступников нацелена даже на самых опытных пользователей, превращая удобство в разрушительную ловушку. Поскольку криптомошенничество продолжает множиться и профессионализироваться, крайне важно понять, как работает эта атака, чтобы лучше от нее защититься.

## Что такое отравление адреса?

Отравление адреса — это форма мошенничества, при которой злоумышленники **манипулируют историей ваших транзакций**, чтобы вас обмануть. Цель состоит в том, чтобы заставить вас отправить средства на вредоносный адрес, который странно похож на легитимный адрес, с которым вы уже взаимодействовали. Киберпреступники эксплуатируют фундаментальную человеческую слабость: склонность проверять только первые и последние символы длинного и сложного адреса.

**Конкретный пример:** Представьте, что вы регулярно отправляете средства на адрес \\\`0x123...abc\\\`. Злоумышленник сгенерирует адрес \\\`0x123...abC\\\` (с небольшим изменением, часто всего одним символом) и внедрит его в вашу историю транзакций. Когда вы захотите отправить средства своему обычному контакту, вы можете непреднамеренно скопировать адрес злоумышленника вместо правильного.

## Как это работает: Механизм мошенничества

Процесс обманчиво прост:

### 1. Внедрение
Злоумышленники мониторят блокчейн, чтобы выявить активные кошельки. Затем они отправляют очень небольшие суммы криптовалют (часто 0 ETH или незначительную часть токена) со своего контролируемого адреса на ваш кошелек. Этот адрес специально разработан, чтобы быть похожим на адрес, с которым вы уже совершали транзакции.

### 2. История
Эта минимальная, но вредоносная транзакция появляется в истории вашего кошелька. Она часто располагается рядом с вашими легитимными транзакциями, увеличивая вероятность того, что вы ее заметите.

### 3. Копирование и вставка
Когда вы хотите совершить новую транзакцию своему обычному контакту, вы можете по привычке или из-за невнимательности скопировать адрес злоумышленника из вашей истории вместо правильного адреса.

### 4. Потеря
После отправки средств на адрес злоумышленника, они **безвозвратно потеряны**. Децентрализованная природа блокчейна делает невозможным отмену транзакции или возврат средств.

## Последствия: Безвозвратная потеря

Опасность отравления адреса заключается в его скрытом характере и окончательности блокчейн-транзакций. После того как вы подтвердили отправку на адрес злоумышленника, нет возможности для обжалования. Средства передаются и исчезают в лабиринтах вредоносных кошельков, часто быстро отмываются, делая любое восстановление почти невозможным.

## Как Lumina Wallet вас защищает: Сканер аудита безопасности адресов

Перед лицом этой растущей угрозы, **Lumina Wallet** позиционируется как ваша первая линия защиты. Наш Сканер аудита безопасности адресов разработан для обнаружения этих невидимых ловушек, прежде чем они обойдутся вам дорого. Вот как он работает:

- **Проверка в реальном времени**: Каждый адрес, с которым вы взаимодействуете, подвергается строгой и мгновенной проверке.
- **Обнаружение вредоносных адресов**: Lumina не просто проверяет техническую валидность (EIP-55). Он перепроверяет информацию с базами данных аналитики угроз в реальном времени (через таких партнеров, как GoPlus Security) для идентификации адресов, известных своей связью с черными списками, фишингом или медовыми ловушками.
- **Четкие оповещения**: Прежде чем вы одобрите транзакцию, Lumina предоставляет вам четкий индикатор безопасности: **зеленый** (безопасно), **желтый** (осторожно) или **красный** (опасно/заблокировано). Это позволяет принять взвешенное решение и избежать дорогостоящих ошибок.

Благодаря Lumina Wallet вы получаете проактивную защиту, которая выходит за рамки простого управления приватными ключами, защищая вас от изощренных мошеннических схем, использующих человеческие слабости.

## Советы по предотвращению для пользователей криптовалют

Хотя Lumina Wallet предлагает расширенную защиту, несколько хороших практик остаются крайне важными:

- **Всегда проверяйте полный адрес**: Уделите время проверке каждого символа адреса назначения, а не только начала и конца.
- **Сделайте небольшой тест**: Прежде чем отправлять крупные суммы, проведите небольшую тестовую транзакцию, чтобы убедиться, что адрес правильный.
- **Используйте безопасные кошельки**: Отдавайте предпочтение кошелькам, которые включают расширенные функции безопасности, такие как сканер адресов Lumina Wallet.

## Заключение: Бдительность, усиленная технологиями

Отравление адреса — это жестокое напоминание о том, что безопасность в криптопространстве – это постоянная борьба. Но с правильными инструментами вы не одиноки. **Lumina Wallet** разработан как ваш щит, сочетая передовые технологии с интуитивно понятным интерфейсом, чтобы обеспечить вам спокойствие. Перемещайтесь в мире криптовалют с полной уверенностью, зная, что Lumina Wallet — ваша первая линия защиты от современных мошенничеств.

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать Lumina Wallet в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "permit2-arnaques-signature-crypto": {
    title: "Permit2 и Мошенничество с Подписью: Защитите Ваш Кошелек от Невидимых Ловушек",
    meta: "Узнайте об опасностях подписей Permit2 и неограниченных разрешений. Узнайте, как Lumina Wallet декодирует каждую подпись, чтобы защитить вас от дренажеров кошельков.",
    body: `## Скрытые опасности подписей транзакций

В экосистеме Web3 подписание транзакции является высшим актом контроля. Это момент, когда вы даете свое согласие на действие в блокчейне. Однако с развитием протоколов и появлением новых функций, таких как **Permit2**, киберпреступники нашли способы превратить этот акт доверия в невидимую ловушку. Вы можете думать, что подписываете простую транзакцию, тогда как на самом деле вы предоставляете неограниченный доступ к своим средствам. Понимание мошенничества с подписями стало необходимым для каждого пользователя криптовалют.

## Что такое Permit2 и почему это полезно?

Permit2 — это инновационный смарт-контракт, изначально разработанный **Uniswap** для упрощения и оптимизации управления одобрениями токенов. Традиционно, для каждого нового токена, который вы хотели обменять на DEX, вам приходилось выполнять отдельную транзакцию одобрения, что стоило газа и занимало время. Permit2 позволяет группировать эти одобрения и управлять ими с помощью «внецепочечных» (off-chain) подписей, делая взаимодействие с DeFi намного более плавным и экономичным.

## Как работают мошенничества с Permit2?

К сожалению, эта возросшая эффективность открыла двери для новых форм фишинга:

### 1. Мошеннические веб-сайты или dApps
Злоумышленники создают платформы, имитирующие популярные DeFi-сервисы. Когда пользователь пытается взаимодействовать с этими сайтами, ему предлагается подписать подпись Permit2.

### 2. Обманчивые подписи
В отличие от классической транзакции, содержимое подписи Permit2 часто представляется в виде **сырых шестнадцатеричных данных**, непонятных для обычного пользователя. Злоумышленник пользуется этим, чтобы подсунуть запрос на неограниченное одобрение для своих собственных адресов.

### 3. Разрушительные последствия
После выполнения подписи злоумышленник получает право переводить ваши токены **без необходимости подписывать новую транзакцию**. Ваш кошелек может быть опустошен в одно мгновение, без каких-либо предупреждающих знаков в блокчейне.

## Почему это так опасно: Невидимая угроза одобрений

Основная опасность мошенничества с подписями заключается в их **невидимости**. Подпись Permit2 не инициирует немедленную транзакцию в блокчейне. Она предоставляет разрешение, которое может быть использовано злоумышленником позже. Более того, техническая сложность подписанных данных делает почти невозможным для неопытного пользователя понять реальные последствия своего действия. Это прямое использование доверия и отсутствия прозрачности.

## Роль Lumina Wallet: Декодер транзакций и подписей

Именно здесь **Lumina Wallet** вступает в игру, чтобы превратить темноту в ясность. Наш Декодер транзакций и подписей — ваш щит от невидимых ловушек:

- **Перевод на понятный язык**: Lumina мгновенно декодирует сложные шестнадцатеричные данные подписей Permit2 и одобрений ERC-20. Он точно показывает, что вы собираетесь подписать, простыми и понятными словами.
- **Полная прозрачность**: Перед каждой подписью Lumina отображает запрошенное действие: это ограниченное или неограниченное одобрение? Кому вы предоставляете доступ к своим средствам?
- **Оценка рисков**: Благодаря нашей системе оценки рисков, кодированной цветом (Safe, Low, Medium, High, Critical), вы немедленно получаете предупреждение, если подпись представляет потенциальную опасность.

С Lumina Wallet вы больше никогда не подписываете вслепую. Вы полностью восстанавливаете контроль над своими взаимодействиями в Web3 благодаря бескомпромиссной прозрачности.

## Рекомендации по безопасности подписей

Чтобы безопасно ориентироваться, примите к сведению следующие практики:

- **Внимательно читайте**: Никогда не подписывайте транзакцию или подпись, не прочитав и не поняв ее детали.
- **Используйте инструменты декодирования**: Отдавайте предпочтение кошелькам, таким как Lumina Wallet, которые переводят технические данные на понятный язык.
- **Отзывайте одобрения**: Привыкайте регулярно отзывать разрешения на токены, которые вы больше не используете.

## Заключение: Подписывайте осознанно с Lumina

Безопасность в Web3 должна быть не роскошью, а стандартом. **Lumina Wallet** стремится предоставить вам необходимые инструменты для защиты от самых сложных угроз. Внося ясность там, где была тень, Lumina позволяет вам в полной мере пользоваться DeFi и криптовалютами в полной безопасности. Подписывайте с уверенностью, подписывайте с Lumina.

[Загрузить Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Загрузить Lumina Wallet в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "faux-wallets-crypto-clones": {
    title: "Поддельные Крипто-Кошельки: Как Распознать Клоны, Которые Опустошают Ваши Счета",
    meta: "Мошенники распространяют идеально клонированные приложения-кошельки, чтобы украсть ваши 12 или 24 слова. Узнайте о признаках мошенничества и защитите свой Web3-портфель.",
    body: `## Анатомия поддельного кошелька

Мошенники вкладывают значительные ресурсы в создание идеальных копий самых популярных кошельков. Эти клоны копируют логотипы, цвета, шрифты и точный интерфейс легитимных приложений. Невооружённым глазом отличить подделку почти невозможно.

Ловушка захлопывается в три этапа:

### 1. Мошенническое распространение
Поддельные кошельки распространяются через обманную рекламу в поисковиках, личные сообщения в социальных сетях (X, Telegram, Discord) или временный обход фильтров официальных магазинов.

### 2. Иллюзия обновления или ошибки
После установки клон имитирует техническую проблему: ложную ошибку соединения, заблокированный баланс или якобы «обязательное обновление безопасности».

### 3. Извлечение секретной фразы
Для «решения» ложной проблемы приложение просит ввести ваши 12 или 24 слова. Как только вы подтверждаете, слова передаются в открытом виде на сервер атакующего, который мгновенно опустошает все ваши счета.

## Тревожные сигналы, которые нельзя игнорировать

- **Запрос seed-фразы** — Легитимный кошелёк, техподдержка или сайт **никогда** не попросят вас ввести фразу восстановления для решения проблемы. Ваши 12 или 24 слова служат только для восстановления аккаунтов на новом устройстве.
- **Необъяснимые всплывающие окна** — Если внезапно появляется окно с просьбой войти в систему, пока вы просматриваете сайт, не связанный с криптовалютой, немедленно закройте его.
- **Источник загрузки** — Скачивайте кошельки и расширения только с официального сайта. Никогда не кликайте по ссылкам из писем или личных сообщений. Проверяйте URL на тонкие опечатки («rn» вместо «m»).

## Безопасность устройства и on-chain безопасность

Некастодиальный кошелёк, такой как **Lumina Wallet**, анализирует транзакции, декодирует смарт-контракты и предупреждает вас, если вы собираетесь отправить средства на опасный адрес. Он сверяет данные с базами угроз в реальном времени, чтобы блокировать on-chain фишинг.

Однако **ни один кошелёк не защитит вас, если устройство скомпрометировано вредоносным ПО** или если вы добровольно вводите seed-фразу в поддельное приложение.

## Ваш чек-лист безопасности

- Скачивайте Lumina Wallet только с [luminawallet.org](https://luminawallet.org) или из официальных магазинов.
- Проверьте издателя: **HÉDONISME SARL** для Lumina Wallet.
- Обновляйте операционную систему и приложения.
- Никогда не вводите seed-фразу, кроме как для добровольного восстановления аккаунта на доверенном устройстве.

## Заключение

Безопасность в Web3 требует комплексной цифровой гигиены. Lumina защищает ваши on-chain взаимодействия; вам предстоит защитить среду, в которой вы работаете.

[Скачать в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "faux-support-arnaques-recuperation-crypto": {
    title: "Поддельная Поддержка и Мошенничество с Восстановлением: Двойной Удар по Крипто-Жертвам",
    meta: "После взлома вторая волна мошенников обещает вернуть ваши средства за плату. Научитесь распознавать поддельные службы восстановления и фальшивых агентов поддержки.",
    body: `> Ищете конкретные шаги после кражи? Читайте [Украденная криптовалюта: что делать в первые 24 часа](/ru/blog/crypto-volees-que-faire).

## Двойной удар

Потеря криптовалюты из-за невнимательности, взлома или мошенничества — травматичный опыт. В последующей панике жертва отчаянно ищет решение. Именно в этот момент максимальной уязвимости появляется вторая категория мошенников: **поддельные службы восстановления и фальшивые агенты техподдержки**.

Эти мошенничества, часто называемые «мошенничеством с авансовыми платежами», основаны на жестокой психологической манипуляции.

> **Определение — мошенничество с восстановлением:** второе мошенничество в отношении уже пострадавшего человека, которому обещают вернуть средства в обмен на плату, конфиденциальные данные или доступ к устройству.

## Мошенничество с восстановлением

Мошенники ведут списки жертв и активно отслеживают форумы, соцсети и разделы комментариев. Механика следующая:

1. **Провиденциальный контакт** — Якобы эксперт по кибербезопасности, «этичный хакер» или фальшивый агент финансового органа связывается с вами, утверждая, что нашёл ваши средства.
2. **Ложное доказательство** — Показывает скриншот заполненного кошелька или сайт с балансом, соответствующим вашим потерям. Оба контролирует он.
3. **Ловушка комиссий** — Ваши средства «готовы к переводу», но нужно сначала оплатить «налог на разблокировку», «сетевые сборы» или «юридическую комиссию».
4. **Спираль** — Если вы платите, они придумают новые предлоги, требуя больше платежей. Никакие средства никогда не возвращаются.

## Поддельная техподдержка

Другой распространённый вариант — выдача себя за службу поддержки известного кошелька или биржи. Эти фальшивые агенты часто работают в X, Telegram или Discord. Как только вы задаёте публичный вопрос, они пишут вам в личку с официальным логотипом и профессиональным тоном.

Их цель всегда одна: заставить вас поделиться seed-фразой или кликнуть по фишинговой ссылке.

## Признаки мошенничества

- **Крипто-транзакции необратимы.** Ни одна компания, хакер или орган не может «отменить» подтверждённую транзакцию.
- **Поддержка никогда не пишет первой.** Легитимные команды никогда не пишут пользователям спонтанно в DM, SMS или по телефону.
- **Seed-фраза табу.** Никакой техподдержке она не нужна.
- **Власти не просят крипту.** Полиция или регуляторы никогда не свяжутся с вами спонтанно для возврата средств.

## Таблица обманных обещаний

| Полученное обещание | Настоящая цель мошенника | Безопасный ответ |
|---|---|---|
| «Мы нашли ваш кошелёк.» | Создать срочную надежду перед требованием оплаты. | Не платите; проверьте через официальные каналы. |
| «Заплатите налог на разблокировку.» | Первый платёж, за которым последуют другие. | Прекратите контакт; сохраните сообщение. |
| «Установите это ПО, чтобы я помог.» | Получить контроль над устройством или украсть секреты. | Откажите в любом удалённом доступе. |
| «Дайте 12/24 слова для ресинхронизации.» | Окончательный контроль над вашими счетами. | Никогда не сообщайте seed-фразу. |

## Как реагировать

1. **Прекратите всё общение** с мошенниками.
2. **Защитите остаток** — переведите активы в новый кошелёк на чистом устройстве; отзовите подозрительные разрешения смарт-контрактов.
3. **Сохраните доказательства** — URL, скриншоты, крипто-адреса, хеши транзакций.
4. **Сообщите и подайте жалобу** в компетентные органы.

## Прозрачность прежде всего

В Lumina Wallet мы создаём инструменты, которые не дают вам отправлять средства мошенникам или одобрять опасные контракты. Наши сканеры анализируют адреса и транзакции до подписи.

Однако мы прозрачны в отношении ограничений технологий: **если мошенническая транзакция подтверждена в блокчейне, Lumina не может её отменить**. Не доверяйте тем, кто утверждает обратное.

[Скачать в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "qr-code-copier-coller-detournement-crypto": {
    title: "QR-Коды и Копирование-Вставка: Когда Адрес Получателя Вам Лжёт",
    meta: "Малварь буфера обмена, поддельные платёжные QR-коды, мошеннические наклейки: узнайте, как мошенники перехватывают ваши крипто-переводы и как Lumina Wallet защищает вас.",
    body: `## Обыденный жест, который стоит дорого

В мире криптовалют адреса — это длинные сложные буквенно-цифровые строки. Никто их не набирает вручную. Для перевода средств мы все полагаемся на два повседневных жеста: **копирование-вставка** и **сканирование QR-кода**.

Мошенники это знают. Вместо взлома криптографии блокчейна они атакуют именно эти два жеста, чтобы перехватить ваши средства в тот самый момент, когда вы инициируете платёж.

> **Определение — перенаправление получателя:** манипуляция, которая заменяет или маскирует адрес, реально используемый для крипто-платежа, в то время как пользователь считает, что отправляет законному получателю.

## Перехват буфера обмена (Clipboard Hijacking)

Атака перехватом буфера обмена страшна своей простотой и скрытностью. Она опирается на вредоносное ПО, установленное на вашем устройстве без вашего ведома.

1. Вы копируете легитимный крипто-адрес получателя.
2. Малварь, постоянно наблюдающая за буфером, обнаруживает формат адреса.
3. За долю секунды заменяет легитимный адрес на адрес хакера в памяти устройства.
4. При вставке в кошелёк появляется адрес хакера.

Если вы подтвердите перевод без внимательной проверки, средства уходят.

## Ловушки QR-кодов

QR-коды упрощают мобильные платежи, но скрывают реальную информацию. QR — это лишь визуальное представление данных: он может содержать крипто-адрес, платёжный запрос, WalletConnect URI или фишинговую ссылку.

Распространённые методы мошенничества:

- **Поддельный платёжный портал** — QR ведёт на сайт, идеально имитирующий легитимную платформу.
- **Телефонная мошенническая схема (предупреждение FTC)** — Мошенник, выдающий себя за представителя власти или службу поддержки, держит вас на телефоне, ведёт к крипто-банкомату и просит отсканировать QR, содержащий адрес его собственного кошелька.
- **Мошенническая наклейка** — В физическом мире преступники наклеивают свой QR поверх легитимного QR-кода продавца.

## Сводная таблица векторов атак

| Вектор | Что видит пользователь | Что на самом деле происходит | Приоритетная проверка |
|---|---|---|---|
| Перехваченный буфер | Адрес только что скопирован из надёжного источника. | Малварь заменила его до вставки. | Сравнить вставленный адрес с оригиналом. |
| Поддельный платёжный QR | Код, представленный как код получателя. | Содержит адрес мошенника. | Подтвердить адрес через второй канал. |
| Фишинговый QR | Быстрый доступ к сервису. | Открывает обманный домен. | Прочитать домен и действие перед продолжением. |
| Наклейка поверх | QR в физическом месте. | Оригинал закрыт. | Осмотреть поверхность; уточнить у продавца. |

## Рефлексы для защиты переводов

- **Всегда проверяйте после вставки**: сравните первые и последние символы с исходным источником.
- **Опасайтесь неожиданных QR** из писем, SMS или соцсетей.
- **Защищайте устройства** обновлённой ОС и хорошим антивирусом.
- **Тестовый перевод** для новых адресов и крупных сумм (удваивает комиссии).
- **Перечитывайте экран подтверждения**: сеть, актив, сумму и конечный адрес.

## Подход Lumina: аудит перед отправкой

Человеческие ошибки неизбежны, поэтому современный кошелёк должен служить страховочной сетью. Вместо универсального сканера, который может увести на вредоносный сайт, Lumina разделяет функции. Сканер экрана отправки читает только крипто-адреса. Если обнаружена веб-ссылка или подозрительная команда, действие немедленно блокируется.

Независимо от того, вставляете вы или сканируете, Lumina не просто принимает адрес — она проводит **мгновенный аудит безопасности**:

- Проверка формата.
- Сверка в реальном времени с базами угроз (как GoPlus Security).
- Чёткое предупреждение до подтверждения.

Вы сохраняете полный контроль, но получаете информацию, необходимую для обнаружения перехвата, пока не поздно.

[Скачать в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "how-to-secure-crypto-wallet": {
    title: "Как защитить криптокошелёк в 2026 году: полное руководство по защите от мошенников",
    meta: "Узнайте, как защитить криптокошелёк с помощью 10 ключевых правил, которым следуют эксперты по безопасности. Сохраните seed-фразу, распознавайте поддельные кошельки, блокируйте вредоносные подписи и обезопасьте свои Bitcoin, Ethereum, Solana и XRP в 2026 году.",
    body: `Если у вас есть криптовалюта, один вопрос важнее любого графика цен: **как защитить криптокошелёк**, чтобы злоумышленник до него никогда не добрался. В 2026 году у пользователей криптовалют было похищено более $3.8 billion — и подавляющее большинство хищений пришлось на **атаки на уровне кошельков**, а не на взломы бирж [1]. Это значит, что за вашу безопасность в первую очередь отвечаете вы сами.

Хорошая новость: защитить криптокошелёк несложно. Это набор простых, осознанных привычек. В этом руководстве вы найдёте точный 10-шаговый метод, которым пользуются заботящиеся о безопасности пользователи, чтобы защитить Bitcoin, Ethereum, Solana, XRP и любые другие цифровые активы, — и узнаете, как специализированное приложение, такое как **Lumina Wallet**, берёт на себя самую сложную работу.

## Почему вопрос «Как защитить мой криптокошелёк» — не совсем тот вопрос

Большинство руководств отвечают на вопрос *«какой кошелёк лучший?»*. Но настоящий вопрос звучит иначе: **как защитить кошелёк, который у меня уже есть?** Ведь в криптовалютах кошелёк надёжен лишь настолько, насколько надёжна ваша самая слабая привычка. Аппаратный кошелёк не спасёт вас, если вы введёте seed-фразу на фишинговом сайте. Некастодиальный кошелёк не защитит, если вы подпишете вредоносный контракт.

Поэтому это руководство посвящено **привычкам и инструментам** — в том порядке, в котором они действительно важны.

## 10 правил, как защитить свой криптокошелёк

### 1. Выбирайте некастодиальный кошелёк — без исключений

Первое правило того, **как защитить криптокошелёк**: никогда не позволяйте кому-то другому хранить ваши ключи.

- ❌ **Кастодиальные кошельки** (большинство бирж, некоторые приложения): платформа хранит ваши приватные ключи. Если её взломают, заморозят аккаунты или она обанкротится — ваша криптовалюта пропадёт.
- ✅ **Некастодиальные кошельки** (такие как Lumina Wallet, MetaMask, Trust Wallet): ключи хранитесь у вас. Между вами и вашими средствами нет посредников.

Запомните главный принцип: **«Не ваши ключи — не ваши монеты».**

### 2. Берегите seed-фразу как все свои сбережения (потому что это они и есть)

Ваша seed-фраза из 12 или 24 слов — это мастер-ключ. Любой, кто ею владеет, может опустошить ваш кошелёк за 30 секунд — из любой точки мира.

**Как хранить её правильно:**

- 📝 **Записывайте на бумаге** (или выгравируйте на металле). Никогда не храните в цифровом виде.
- 🚫 **Никогда не фотографируйте** её. Не храните в iCloud, Google Drive, «Заметках» или в любом менеджере паролей, подключённом к интернету.
- 🔒 **Сделайте 2–3 физические копии** и храните их в разных надёжных местах (домашний сейф, доверенный член семьи, банковская ячейка).
- 🗣️ **Никому её не сообщайте**. Ни службе поддержки. Ни «разработчикам кошелька». Ни «сотрудникам налоговой». Ни один законный человек никогда её не спросит.

> ⚠️ **Золотое правило**: если человек, сайт или приложение просит вашу seed-фразу — это на 100% мошенничество. Без исключений.

### 3. Используйте надёжный и уникальный пароль для кошелька

Пароль кошелька шифрует ваши ключи локально на вашем устройстве. Используйте:

- Не менее **14 символов**
- Сочетание заглавных и строчных букв, цифр и символов
- **Пароль, отличающийся от всех остальных ваших паролей**
- Хранение в менеджере паролей (Bitwarden, 1Password, KeePass)

### 4. Включите биометрическую аутентификацию и PIN-код

Современные криптокошельки поддерживают Face ID, сканер отпечатков пальцев и 6-значный PIN-код. Включите **все три уровня**. Даже если кто-то украдёт ваш телефон, он не сможет открыть кошелёк без вашей биометрии.

### 5. Остерегайтесь поддельных приложений-кошельков

Мошенники публикуют **приложения-клоны** в Google Play и App Store с названиями вроде *«Lumina Wallet Pro»*, *«Lumina — Free Airdrop»* или с копиями логотипа. Выглядят они идентично, но крадут вашу seed-фразу в тот момент, когда вы её вводите.

**Как не попасться на поддельные кошельки:**
- ✅ Скачивайте только по **официальным ссылкам** с сайта проекта (например, https://luminawallet.org)
- ✅ Проверяйте, что **имя разработчика** совпадает (для Lumina Wallet: *Lumina Wallet* от HEDONISME SARL)
- ✅ Смотрите на количество загрузок и отзывов — у клонов обычно <100 загрузок
- ✅ Прочитайте наше полное руководство о [поддельных клонах кошельков](/en/blog/fake-crypto-wallet-clones)

### 6. Проверяйте адрес получателя перед каждой отправкой

Атаки с подменой адреса (address poisoning) набирают обороты: мошенники отправляют вам крошечную транзакцию с адреса, который **похож** на один из ваших постоянных (совпадают первые 4 и последние 4 символа, середина другая). Вы копируете адрес из истории и отправляете средства прямо злоумышленнику.

**Как этого избежать:**
- ✅ Всегда проверяйте **адрес целиком**, а не только начало и конец
- ✅ Используйте кошелёк с **адресной книгой** для сохранения доверенных контактов (в Lumina она встроена)
- ✅ Перед крупными переводами сначала отправляйте **небольшую тестовую транзакцию**

### 7. Никогда не подписывайте транзакцию, которую не понимаете

Самая технически сложная афера 2026 года — **вредоносная подпись**: вы нажимаете «Sign» на кнопке, похожей на вход в систему, а на деле одобряете неограниченный лимит расходов вашего USDC/ETH. Злоумышленники опустошают кошелёк уже на следующий день.

**Контрольный список перед подписью:**
- 🔍 Прочитайте данные транзакции — какой токен? Какая сумма? Какой контракт?
- 🚨 **«Unlimited approval»** или **«setApprovalForAll»** = тревожный сигнал
- 🚨 **Запрос подписи от сайта, на который вы только что попали** = тревожный сигнал
- 🚨 Кошелёк пишет *«This transaction might be dangerous»* = СТОП

Кошелёк со **сканером транзакций** (как Lumina Wallet) выявляет такие атаки до того, как вы поставите подпись.

### 8. Обновляйте приложение кошелька и ОС телефона

Каждое обновление кошелька содержит **исправления безопасности** для недавно обнаруженных уязвимостей. То же касается операционной системы телефона. Устаревшее приложение — это известная поверхность атаки.

- 📱 Включите **автообновления** в Google Play и App Store
- 🔐 Обновляйте ОС телефона в течение недели после выхода любого обновления безопасности

### 9. Никогда не подключайте кошелёк к неизвестным сайтам

DApps — мощный инструмент, но подключение кошелька к мошенническому сайту может обойтись вам в одну подпись.

**Правила:**
- Подключайтесь только к **URL, которые вы набрали сами** или которые взяты из официальных социальных каналов
- Никогда не подключайтесь по ссылке из личных сообщений в Discord/Telegram
- После использования DApp **отзывайте разрешения** на [revoke.cash](https://revoke.cash)
- Добавляйте надёжные DApps в закладки и никогда не ищите их через Google (реклама в Google полна мошеннических клонов)

### 10. Используйте кошелёк со встроенной защитой от мошенников

Вы — человек. Вы будете уставать. Вы будете кликать слишком быстро. Поэтому последний рубеж обороны — это кошелёк, который **ловит мошенников за вас** — прежде чем вы совершите дорогостоящую ошибку.

## Как Lumina Wallet автоматически защищает вашу криптовалюту

Lumina Wallet создан специально для того, чтобы устранить главную единую точку отказа в криптовалютах: **человеческую ошибку под давлением**. Вот как он защищает вас на каждом шаге:

| Угроза | Как Lumina её блокирует |
|---|---|
| **Фишинговый адрес** | Сканер в реальном времени сверяет каждого получателя с актуальным чёрным списком из более чем 500,000 известных мошеннических адресов. При совпадении — красное предупреждение. |
| **Вредоносный смарт-контракт** | Перед подписью Lumina симулирует транзакцию и показывает, *какие именно* токены покинут ваш кошелёк. Если обнаружены неограниченные разрешения или схемы вывода средств, вы получите критическое предупреждение. |
| **Подмена адреса (address poisoning)** | Lumina автоматически помечает адреса, похожие на те, что есть в вашей истории, — даже если отличается всего 1 символ, — до отправки. |
| **Поддельные permit-подписи** | Подписи ERC-20 Permit и Permit2 расшифровываются и объясняются простым языком. Больше никакой «слепой» подписи. |
| **Некастодиальность по замыслу** | Ваши ключи шифруются на вашем устройстве с помощью AES-256 + Secure Enclave. Серверы Lumina их никогда не видят. Не увидят их ни правоохранительные органы, ни хакеры, ни конкурсная масса при банкротстве. |
| **Биометрия + PIN + пароль** | Трёхуровневая блокировка, настройка каждого уровня необязательна — вы выбираете комфортный для себя вариант. |

## А как насчёт аппаратных кошельков?

Аппаратные кошельки (Ledger, Trezor) добавляют надёжный дополнительный уровень защиты для **долгосрочных накоплений** (>$10k, к которым вы не прикасаетесь каждую неделю). Но они не заменяют 10 правил выше — они их дополняют. Даже с Ledger вредоносная подпись, которую вы одобрите, опустошит ваши средства.

Для повседневного использования (обмены, переводы, DeFi) **защищённый мобильный кошелёк со сканером транзакций** часто *безопаснее*, чем «голый» аппаратный кошелёк, потому что он ловит атаки, основанные на человеческой ошибке, которые аппаратные кошельки предотвратить не могут.

## Распространённые ошибки, разрушающие безопасность кошелька

Даже пользователи, знающие правила, совершают эти ошибки. Избегайте их:

- ❌ **Делать скриншот seed-фразы** «просто для резервной копии» — iCloud/Google Photos синхронизирует его с облаком
- ❌ **Использовать один и тот же пароль** для кошелька и электронной почты
- ❌ **Переходить по рекламе Google** для приложений-кошельков или DApps (мошенническая реклама встречается часто)
- ❌ **Хранить криптовалюту на биржах** долгое время «потому что так проще»
- ❌ **Игнорировать предупреждения безопасности** из-за спешки
- ❌ **Проверять «airdrop» от незнакомцев**, подключая свой основной кошелёк

## Краткий чек-лист безопасности (сохраните его)

Прежде чем вложить в криптовалюту ещё хоть один евро, убедитесь, что вы выполнили все 10 пунктов:

- [ ] Я использую некастодиальный кошелёк (ключи хранятся у меня)
- [ ] Моя seed-фраза записана на бумаге и хранится минимум в 2 физических местах
- [ ] Моя seed-фраза никогда не попадала в интернет
- [ ] Пароль моего кошелька состоит из 14+ символов и уникален
- [ ] Биометрия и PIN-код включены
- [ ] Я скачал кошелёк только с официального сайта
- [ ] Я всегда проверяю адрес получателя целиком
- [ ] Я никогда не подписываю транзакции, которых не понимаю
- [ ] Мой кошелёк и ОС телефона обновлены до актуальной версии
- [ ] Я подключаюсь только к тем DApps, которым однозначно доверяю

## Заключение: безопасность — это привычка, а не разовая настройка

Безопасность кошелька нельзя передать на аутсорс. Но можно сделать её в 10 раз проще, сочетая **хорошие привычки** с **инструментами, которые защищают вас, когда вы ошибаетесь**. Именно это делает Lumina Wallet — некастодиальный мультичейн-кошелёк со встроенным сканером мошенничества, проверкой адресов и симуляцией транзакций.

Каждая транзакция проверяется. Каждая подпись расшифровывается. Каждый риск объясняется простым языком — до того, как вы примете решение.

**Готовы защитить свой криптокошелёк правильно?**

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)

---

### Источники

[1] Chainalysis. (2026). *2026 Crypto Crime Report: Wallet-level attacks*. [https://www.chainalysis.com/blog/crypto-scams-2026/](https://www.chainalysis.com/blog/crypto-scams-2026/)`
  },
  "what-is-non-custodial-wallet": {
    title: "Что такое некастодиальный кошелёк? Полное руководство для начинающих (2026)",
    meta: "Некастодиальный кошелёк позволяет вам самостоятельно владеть ключами от своей криптовалюты — без банка, без биржи, без посредников. Узнайте, что означает «некастодиальный», чем он отличается от кастодиального кошелька, и посмотрите реальные примеры: Lumina Wallet, MetaMask и Trust Wallet.",
    body: `**Некастодиальный кошелёк** — это криптовалютный кошелёк, в котором **приватные ключи, управляющие вашими средствами, храните вы — и только вы**. Ни банк, ни биржа, ни какая-либо третья сторона не могут получить доступ к вашей криптовалюте, заморозить её или потерять. Если вы новичок в крипто, это самое важное понятие, которое нужно усвоить. В этом руководстве мы объясняем, что такое некастодиальный кошелёк, как он работает, приводим реальные примеры и помогаем понять, подходит ли он именно вам.

## Что значит «некастодиальный кошелёк»: определение за 30 секунд

**Определение некастодиального кошелька**: криптовалютный кошелёк, в котором пользователь сохраняет полное владение своими приватными ключами. Ни одна третья сторона не имеет доступа к средствам. Пользователь — единственный хранитель.

Простыми словами: **если вы не можете лишиться доступа к своим деньгам из-за того, что компания решила заморозить ваш аккаунт, значит, у вас некастодиальный кошелёк.**

### Кастодиальный и некастодиальный кошелёк: краткое сравнение

| Характеристика | Кастодиальный кошелёк | Некастодиальный кошелёк |
|---|---|---|
| **Кто хранит ваши ключи?** | Биржа/компания | Вы |
| **Могут ли заморозить аккаунт?** | Да, компания | Нет — никто не может заморозить |
| **Что, если компания обанкротится?** | Средства могут быть потеряны или заблокированы | Средства в полной безопасности |
| **Нужно ли помнить seed-фразу?** | Нет (её хранит компания) | Да (её храните вы) |
| **Риск изъятия государством?** | Да (по судебному запросу) | Только если вас принудят выдать ключи |
| **Примеры** | Coinbase, Binance, Kraken (их кошелёк по умолчанию) | Lumina Wallet, MetaMask, Ledger, Trust Wallet |

## Как работает некастодиальный кошелёк?

Когда вы создаёте некастодиальный кошелёк, на вашем устройстве локально происходят три вещи:

1. **Генерируется приватный ключ** — огромное случайное число, которое математически управляет вашими криптоадресами.
2. **Создаётся seed-фраза** — 12 или 24 слова, удобных для человека, из которых можно восстановить приватный ключ. Это ваша единственная резервная копия.
3. **Выводится публичный адрес** — «адрес для получения», которым вы делитесь с другими.

Приватный ключ **никогда не покидает ваше устройство**. Когда вы отправляете криптовалюту, кошелёк подписывает транзакцию локально, а затем передаёт в блокчейн только подпись. Ни один сервер не видит ваш ключ. Именно поэтому кошелёк называется *некастодиальным*: внешнего хранителя нет никогда.

## Пример некастодиального кошелька: реальная транзакция

Вот что происходит, когда вы отправляете 0.1 ETH из некастодиального кошелька вроде Lumina:

1. Вы вводите адрес получателя и сумму
2. Кошелёк **подготавливает** данные транзакции (отправитель, получатель, сумма, комиссия за газ)
3. Кошелёк **подписывает** транзакцию вашим приватным ключом — это происходит на 100% на вашем телефоне
4. В сеть Ethereum отправляется **подписанная транзакция** (а не ключ)
5. Майнеры/валидаторы проверяют, что подпись математически корректна
6. Транзакция подтверждается в блокчейне

Ни на каком этапе никакая компания не имеет возможности отменить, заблокировать или заморозить этот перевод. В этом и заключаются свобода — и ответственность — некастодиальных кошельков.

## Почему стоит выбрать некастодиальный криптокошелёк?

### 1. Вы сами себе банк

Причина номер один — **настоящее владение**. В 2022 году рухнула FTX, и миллиарды средств пользователей за одну ночь стали недоступны. Пользователей некастодиальных кошельков это совершенно не затронуло. То же самое произошло в 2023 году с Celsius, Voyager и BlockFi.

> **«Не ваши ключи — не ваши монеты».** — Эта короткая мантра уберегла от потерь миллионы пользователей.

### 2. Полная приватность

Кастодиальная биржа требует прохождения KYC (верификации личности), отслеживает каждую транзакцию и передаёт сведения налоговым органам и регуляторам. Некастодиальному кошельку нужна лишь ваша seed-фраза — без электронной почты, без документов, без регистрации. Создать его можно за 30 секунд.

### 3. Никаких лимитов на вывод и замороженных аккаунтов

Кастодиальные платформы замораживают аккаунты из-за «подозрительной активности», проверок регуляторов или технических работ — порой на недели. У некастодиальных кошельков такого трения нет: ваши средства всегда доступны, 24/7, из любой точки, где есть интернет.

### 4. Доступ к DeFi и Web3

Почти каждый DeFi-протокол (Uniswap, Aave, Lido), NFT-маркетплейс (OpenSea, Magic Eden) и Web3-приложение требует подключения некастодиального кошелька. Кастодиальные кошельки не могут участвовать в ончейн-приложениях.

## Что включает в себя разработка некастодиального кошелька?

Для разработчиков, интересующихся **разработкой некастодиальных кошельков**, вот технологический стек:

- 🔐 **Генерация ключей**: BIP-32 (иерархические детерминированные ключи) + BIP-39 (мнемонические seed-фразы) + BIP-44 (деривация для нескольких аккаунтов)
- 🔗 **Поддержка нескольких блокчейнов**: RPC-провайдеры или собственные ноды для каждого блокчейна (Bitcoin, Ethereum, Solana, XRP и др.)
- 💾 **Локальное защищённое хранилище**: iOS Secure Enclave / Android Keystore для шифрования ключей
- ✍️ **Подпись транзакций**: ECDSA для Bitcoin/Ethereum, Ed25519 для Solana — всё на стороне клиента
- 🛡️ **Уровни защиты**: антискам-сканирование, адресная книга, симуляция транзакций

Lumina Wallet — это **некастодиальный мобильный кошелёк**, созданный со всем перечисленным выше, а также со **встроенным антискам-сканером** — ведь владение без защиты становится ловушкой для новичков.

## Единственный компромисс: ответственность лежит на вас

Некастодиальный кошелёк означает, что вы владеете своими ключами, но также и то, что **вы на 100% отвечаете за их сохранность**.

- 🔴 **Потеряли seed-фразу = потеряли криптовалюту**. Кнопки «забыли пароль» нет. Никакая служба поддержки не поможет.
- 🔴 **Попались на фишинг = потеряли криптовалюту**. Подписанную транзакцию никто не может отменить.
- 🔴 **Подписали вредоносный контракт = потеряли криптовалюту**. Это полностью ваша ответственность.

Именно поэтому современные некастодиальные кошельки, такие как Lumina, добавляют уровни защиты:
- ✅ Сканер мошенничества в реальном времени, блокирующий известные фишинговые адреса
- ✅ Симуляция транзакции перед подписанием
- ✅ Понятные предупреждения о подозрительных подписях «Permit» или «Approve»
- ✅ Адресная книга для защиты от опечаток и атак подмены при копировании и вставке

## Примеры некастодиальных кошельков в 2026 году

Лучшие некастодиальные криптокошельки на сегодня с точки зрения безопасности, удобства и поддержки нескольких блокчейнов:

| Кошелёк | Тип | Блокчейны | Лучше всего подходит для |
|---|---|---|---|
| **Lumina Wallet** | Мобильный | 10+ (BTC, ETH, SOL, XRP, BNB, POL...) | Повседневного использования + защиты от мошенников |
| **MetaMask** | Браузер + мобильный | EVM-сети, Solana и Bitcoin | Продвинутых пользователей DeFi |
| **Trust Wallet** | Мобильный | 70+ | Обычных пользователей с несколькими блокчейнами |
| **Ledger** | Аппаратный | 100+ | Долгосрочного холодного хранения |
| **Rabby** | Браузер | Экосистема Ethereum | Продвинутого DeFi с симуляцией транзакций |

## Некастодиальный мобильный кошелёк: безопасен ли он?

Да — если соблюдать базовые правила безопасности. Мобильный некастодиальный кошелёк часто **безопаснее биржи** по следующим причинам:

- Ваши ключи шифруются аппаратным модулем безопасности вашего телефона
- Вы получаете биометрическую аутентификацию + PIN-код
- Современные кошельки (например, Lumina) сканируют каждую транзакцию на предмет мошенничества
- Нет единой «мишени» для хакеров — 100 миллионов кошельков = 100 миллионов отдельных целей

Для сумм до €10,000, которыми вы регулярно пользуетесь, хорошо спроектированный некастодиальный мобильный кошелёк обеспечивает лучший баланс между безопасностью и удобством.

## Как начать работу с первым некастодиальным кошельком

1. **Скачайте приложение** с официального сайта (а не через поиск в магазине приложений — существуют клоны)
2. **Создайте новый кошелёк** — приложение сгенерирует ключи локально
3. **Запишите seed-фразу из 12 слов** на бумаге и храните в надёжном месте
4. **Задайте надёжный пароль** и включите биометрию
5. **Сначала отправьте небольшую тестовую сумму**, чтобы убедиться, что всё работает
6. **Прочитайте наше [руководство по безопасности кошелька из 10 шагов](/en/blog/how-to-secure-crypto-wallet)** прежде чем хранить крупные суммы

## Некастодиальный кошелёк: часто задаваемые вопросы

### Некастодиальный кошелёк — это то же самое, что горячий кошелёк?

Не совсем. *Горячий кошелёк* означает «подключённый к интернету». *Некастодиальный* означает «ключи хранит пользователь». Кошелёк может быть одновременно горячим И некастодиальным (Lumina, MetaMask) — или некастодиальным и холодным (Ledger, Trezor).

### Что будет, если я потеряю телефон?

Ничего плохого — пока у вас есть seed-фраза. Установите кошелёк на новый телефон, импортируйте seed-фразу, и ваши средства мгновенно вернутся.

### Могу ли я превратить кастодиальный кошелёк в некастодиальный?

«Превратить» его нельзя, но вы можете вывести средства с кастодиальной биржи на новый некастодиальный кошелёк, который вы создали. Это рекомендуемый путь для всех, кто хранит значительные суммы в криптовалюте.

### Платят ли некастодиальные кошельки налоги?

Некастодиальные кошельки не передают данные налоговым органам автоматически, но налоги с прибыли всё равно должны платить *вы*. Используйте такие инструменты, как Koinly или CoinTracker, чтобы рассчитать налоги по истории транзакций вашего кошелька.

## Заключение: владейте своей криптовалютой по-настоящему

Если вы серьёзно относитесь к крипто, некастодиальный кошелёк — это не опция, а фундамент. Каждый год пользователи теряют целые состояния из-за банкротств бирж, заморозки аккаунтов или взломов платформ. Ничто из этого не может затронуть правильно защищённый некастодиальный кошелёк.

**Lumina Wallet — это некастодиальный мультичейн-кошелёк** со встроенным сканером мошенничества, адресной книгой, симуляцией транзакций и поддержкой более 10 блокчейнов — созданный для тех, кто хочет владения *и* защиты.

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "lumina-wallet-vs-lumina-token": {
    title: "Lumina Wallet против Lumina Coin, Pay, Chain: не путайте эти проекты",
    meta: "Путаетесь между Lumina Wallet и другими криптопроектами с названием «Lumina» (Lumina Coin, Lumina Pay, Lumina Chain, Lumina Crest AI)? Вот чёткие различия, чтобы вы не попали в ловушку из-за схожего названия.",
    body: `Вы искали в Google «Lumina crypto» и обнаружили сразу несколько разных проектов с названием «Lumina»? Это нормально — и именно эту путаницу мы хотим развеять. **Lumina Wallet НЕ имеет никакого отношения к проектам «Lumina Coin», «Lumina Pay», «Lumina Chain Base» или «Lumina Crest AI»**, которые вам могут встретиться в интернете. Вот как чётко их различать.

## Кто такой Lumina Wallet на самом деле?

**Lumina Wallet** — это мобильное **некастодиальное** криптовалютное кошелёк-приложение, опубликованное компанией **HEDONISME SARL** (французская компания, зарегистрированная в RCS Dunkerque под номером 901 439 505).

### Наши уникальные особенности:
- 📱 **Мобильное приложение** доступно в [Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) и [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)
- 🔐 **Некастодиальный**: только вы владеете своими приватными ключами
- 🌐 **Мультичейн**: Bitcoin, Ethereum, Solana, XRP, BNB, Polygon и более 5 других блокчейнов
- 🛡️ **Встроенный антискам-сканер**: это наше главное отличие
- 🇫🇷 **Французская компания**, которую можно проверить в торговом реестре RCS
- 🌍 **Единственный официальный сайт**: [luminawallet.org](https://luminawallet.org)

### Чем Lumina Wallet НЕ является:
- ❌ **НЕ токен / криптовалюта** — у нас нет собственного токена
- ❌ **НЕ блокчейн первого или второго уровня** — мы подключаемся к существующим блокчейнам
- ❌ **НЕ платформа автоматизированных инвестиций** — мы не предлагаем «гарантированную доходность»
- ❌ **НЕ B2B-платёжный сервис** — мы кошелёк для частных пользователей
- ❌ **НЕ ИИ-проект** — мы приложение для криптобезопасности

## Другие проекты «Lumina» (не связанные с нами)

Вот основные криптопроекты со словом «Lumina» в названии, с которыми вы можете столкнуться:

### 1. Lumina Coin / Lumina Token

На различных блокчейнах существует несколько токенов стандарта ERC-20 с названием «Lumina» или «LUMI». Это **спекулятивные криптовалюты**, выпущенные сторонними проектами.

⚠️ **Предупреждение**: часть этих токенов стала жертвой rug pull (мошеннические схемы, при которых команда исчезает вместе с ликвидностью). Всегда проверяйте команду, контракт и ликвидность **перед инвестированием**.

**Связь с Lumina Wallet: ОТСУТСТВУЕТ.** Мы не выпускаем никаких токенов.

### 2. Lumina Pay

Некоторые платформы используют название «Lumina Pay» для криптоплатёжных или необанковских сервисов. И снова — **никакой связи с Lumina Wallet**.

### 3. Lumina Chain / Lumina Base

Существуют проекты, которые представляют себя как блокчейны первого уровня или роллапы под названием «Lumina Chain» или «Lumina Base». **Никакой связи** с нашим кошельком — мы не разрабатываем блокчейн.

### 4. Lumina Crest AI

⚠️ **Особое предупреждение по этому проекту.** О Lumina Crest AI ходит множество сообщений о подозрительных практиках (гарантированная доходность, заблокированные выводы средств). Прежде чем связываться с этим проектом, поищите в Google «Lumina Crest AI review».

**Lumina Wallet не имеет абсолютно ничего общего с Lumina Crest AI.**

## Как убедиться, что вы используете настоящий Lumina Wallet

Чтобы быть уверенными, что вы пользуетесь нашим легитимным приложением, а не подделкой:

### ✅ Что нужно проверить:

1. **Единственный официальный сайт**: [https://luminawallet.org](https://luminawallet.org)
   - Никакой другой домен не представляет Lumina Wallet
2. **Google Play**: имя разработчика = *Lumina Wallet*, пакет = \`com.luminawallet.app\`
3. **App Store**: ID приложения = \`id6760651380\`, издатель = *Lumina Wallet*
4. **Официальный Twitter/X**: [@getluminawallet](https://x.com/getluminawallet)
5. **Все наши социальные сети** перечислены на [странице «О нас»](/en/about)

### 🚨 Тревожные признаки (мошенничество):

- Сайт, требующий вашу seed-фразу, чтобы «подключить» кошелёк
- «Airdrop Lumina», требующий предварительной оплаты «gas fee»
- «Поддержка Lumina», которая пишет вам в личные сообщения в Telegram или Discord
- Проект, обещающий доходность с «токеном Lumina»
- Сайт, похожий на наш, но с другим URL (например, \`lumina-wallet.org\` с дефисом, \`luminawallet.com\`, \`luminawallets.org\`)

## Почему возникает эта путаница

Название «Lumina» (от латинского *lumen* — свет) популярно в крипте, потому что вызывает ассоциации с ясностью и прозрачностью. В результате **множество независимых команд** взяли это название без какой-либо координации.

В **Lumina Wallet** мы выбрали это имя, чтобы отразить нашу миссию: **сделать криптобезопасность понятной и светлой** с помощью сканера мошенничества, который выявляет скрытые риски перед каждой транзакцией.

## Заключение

Если вы искали токен «Lumina Coin», «Lumina Pay» или любую другую криптовалюту/платформу с этим названием: **это не мы, и мы не имеем к ним никакого отношения**. Проведите собственное исследование (DYOR) по этим сторонним проектам.

Если же вы ищете **некастодиальный мультичейн мобильный криптокошелёк со встроенной защитой от мошенничества**, опубликованный **прозрачной зарегистрированной французской компанией** — вы по адресу.

**Откройте для себя Lumina Wallet — единственный и неповторимый:**

[Скачать в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "best-non-custodial-crypto-wallet-2026": {
    title: "Лучший некастодиальный криптокошелёк 2026 года: полное сравнение",
    meta: "Сравнение лучших некастодиальных криптокошельков 2026 года: Lumina Wallet, MetaMask, Trust Wallet, Rabby, Rainbow, Coinbase Wallet и Ledger. Функции, безопасность, поддержка мультичейна и защита от мошенников — в одной таблице.",
    body: `Выбрать **лучший некастодиальный криптокошелёк** в 2026 году сложнее, чем когда-либо. Вариантов десятки — мобильные, браузерные, аппаратные, — и каждый называет себя самым безопасным, самым простым или самым функциональным. Это руководство поможет разобраться: мы провели **сравнение бок о бок** семи самых популярных некастодиальных кошельков на основе реальных функций, реальной безопасности и реального пользовательского опыта.

## Что такое некастодиальный кошелёк? (Краткое напоминание за 30 секунд)

[Некастодиальный кошелёк](/en/blog/what-is-non-custodial-wallet) — это криптокошелёк, в котором приватными ключами управляете **вы** и только вы. Ни биржа, ни банк, ни третья сторона не могут заморозить, изъять или потерять ваши средства. Обратная сторона: вы на 100% отвечаете за свою seed-фразу.

Некастодиальные кошельки бывают трёх видов:
- **Мобильные** (Lumina, Trust Wallet, Rainbow) — лучший выбор для повседневного использования
- **Браузерные расширения** (MetaMask, Rabby) — лучший выбор для опытных пользователей DeFi
- **Аппаратные** (Ledger, Trezor) — лучший выбор для долгосрочного холодного хранения

## 7 лучших некастодиальных кошельков 2026 года — сравнение

| Кошелёк | Тип | Сети | Антискам-сканер | Фильтр фейковых токенов | Лучше всего подходит для |
|---|---|---|---|---|---|
| **Lumina Wallet** | Мобильный | 10+ (BTC, ETH, SOL, XRP, BNB, POL...) | ✅ Встроенный, в реальном времени | ✅ Белый список по контрактам | Обычных пользователей, которым нужна **безопасность без сложностей** |
| **MetaMask** | Браузер + мобильный | EVM-сети, Solana и Bitcoin | ⚠️ Базовые предупреждения | ❌ Показывает все токены | Опытных пользователей DeFi |
| **Trust Wallet** | Мобильный | 70+ | ⚠️ Сторонний сканер | ❌ Показывает все токены | Обычных пользователей мультичейна |
| **Rabby** | Браузер | Экосистема Ethereum | ✅ Симуляция транзакций | ❌ Показывает все токены | Продвинутого DeFi с предпросмотром транзакций |
| **Rainbow** | Мобильный | Экосистема Ethereum | ⚠️ Базовые предупреждения | ❌ Показывает все токены | Пользователей только Ethereum, отличный UX |
| **Coinbase Wallet** | Мобильный + браузер | 20+ | ⚠️ Базовые предупреждения | ❌ Показывает все токены | Пользователей биржи Coinbase |
| **Ledger (с Ledger Live)** | Аппаратный | 100+ | ❌ Нет сканера | ❌ Показывает все токены | Долгосрочного холодного хранения (>10 тыс. €) |

## Подробный разбор: каждый кошелёк в деталях

### 🥇 Lumina Wallet — лучший выбор для ежедневного использования с упором на безопасность

**Сильные стороны:**
- ✅ Некастодиальный, ключи зашифрованы с помощью iOS Secure Enclave / Android Keystore
- ✅ **Трёхуровневый антискам-сканер** (считыватель QR-кодов, аудит адресов, декодер транзакций)
- ✅ **Фильтр фейковых токенов** — в кошельке отображаются только официальные контракты
- ✅ Поддержка мультичейна: Bitcoin, Ethereum, Solana, XRP, BNB Chain, Polygon, Arbitrum, Optimism, Base, Avalanche
- ✅ Подписи ERC-20 Permit и Permit2 расшифровываются простым языком
- ✅ Адресная книга для защиты от опечаток и атак с подменой при копировании и вставке
- ✅ Данные об угрозах GoPlus Security в реальном времени
- ✅ **Французская компания** (HEDONISME SARL, RCS Dunkerque) — прозрачная структура собственности

**Слабые стороны:**
- Пока не имеет открытого исходного кода (планируется)
- Пока только мобильная версия (нет браузерного расширения)

**Идеально подходит для:** тех, кто хочет **максимальной безопасности, не становясь криптоэкспертом**. Особенно для новичков и пользователей среднего уровня.

**Вердикт:** ⭐⭐⭐⭐⭐

### 🥈 MetaMask — выбор опытных пользователей DeFi

**Сильные стороны:**
- ✅ Самый широко поддерживаемый кошелёк среди Web3-приложений
- ✅ Доступен и как браузерное расширение, и как мобильное приложение
- ✅ Экосистема Snaps для расширения функциональности
- ✅ Открытый исходный код

**Слабые стороны:**
- ⚠️ По умолчанию показывает все токены → фейковые токены засоряют кошелёк
- ⚠️ Предупреждения о подписях базовые, и их легко проигнорировать
- ⚠️ Consensys (материнская компания) критиковали за сбор данных

**Идеально подходит для:** опытных пользователей DeFi, которые понимают, что делают.

**Вердикт:** ⭐⭐⭐⭐

### 🥉 Trust Wallet — самая широкая поддержка сетей

**Сильные стороны:**
- ✅ Поддержка 70+ блокчейнов (лучший показатель в своём классе)
- ✅ Встроенный агрегатор DEX
- ✅ Принадлежит Binance (большая команда, хорошее финансирование)

**Слабые стороны:**
- ⚠️ Базовая защита от мошенников (в основном реактивная, а не проактивная)
- ⚠️ Показывает все токены → риск спама фейковыми токенами
- ⚠️ Инциденты в прошлом (уязвимость WalletConnect в 2023 году, раскрытая слабость MPC)

**Идеально подходит для:** пользователей, активных в малоизвестных сетях.

**Вердикт:** ⭐⭐⭐

### Rabby — лучший в своём классе предпросмотр транзакций

**Сильные стороны:**
- ✅ Симулирует каждую транзакцию до подписания (показывает точное изменение баланса)
- ✅ Открытый исходный код
- ✅ Переключение между сетями без ручного добавления

**Слабые стороны:**
- ⚠️ Только браузер (нет мобильной версии)
- ⚠️ Только экосистема Ethereum
- ⚠️ Более высокий порог входа

**Идеально подходит для:** опытных пользователей DeFi, которые хотят видеть последствия до подписания.

**Вердикт:** ⭐⭐⭐⭐

### Rainbow — лучший UX (но только Ethereum)

**Сильные стороны:**
- ✅ Красивый, интуитивно понятный интерфейс
- ✅ Отличный онбординг для новичков
- ✅ Открытый исходный код

**Слабые стороны:**
- ⚠️ Только экосистема Ethereum
- ⚠️ Ограниченные антискам-функции
- ⚠️ Проблема спама фейковыми токенами

**Идеально подходит для:** обычных пользователей только Ethereum, ценящих эстетику.

**Вердикт:** ⭐⭐⭐

### Coinbase Wallet — мост к бирже

**Сильные стороны:**
- ✅ Бесшовная интеграция с биржей Coinbase
- ✅ Поддержка мультичейна
- ✅ Надёжный бренд

**Слабые стороны:**
- ⚠️ Базовые антискам-функции
- ⚠️ Опасения по поводу сбора данных (соответствие регулированию США)
- ⚠️ Показывает все токены

**Идеально подходит для:** пользователей биржи Coinbase, переходящих на самостоятельное хранение.

**Вердикт:** ⭐⭐⭐

### Ledger + Ledger Live — лучший выбор для долгосрочного хранения

**Сильные стороны:**
- ✅ Аппаратная изоляция — ключи никогда не попадают в интернет
- ✅ Поддержка 100+ сетей
- ✅ Лучшее решение для крупных активов (>10 000 €)

**Слабые стороны:**
- ⚠️ Устройство стоит от 79 € до 249 €
- ⚠️ Физическое устройство, которое нужно носить с собой и которое можно потерять
- ⚠️ Утечка данных в 2020 году (адреса электронной почты клиентов)
- ⚠️ Нет антискам-сканера — вы по-прежнему уязвимы для вредоносных подписей

**Идеально подходит для:** владельцев крупных сумм в качестве сберегательного хранилища.

**Вердикт:** ⭐⭐⭐⭐ (только для долгосрочного хранения)

## Какой некастодиальный кошелёк подходит именно ВАМ?

Задайте себе три вопроса:

### 1. Сколько криптовалюты у меня есть?
- **< 1 000 €** → **Lumina Wallet** (мобильный, безопасный, бесплатный)
- **1 000 € – 10 000 €** → **Lumina Wallet** для ежедневного использования + при желании Ledger для накоплений
- **> 10 000 €** → **Ledger** для холодного хранения + Lumina Wallet для повседневных транзакций

### 2. Активен ли я в DeFi?
- **Нет, я просто храню и отправляю** → **Lumina Wallet**
- **Да, но изредка** → **Lumina Wallet** (WalletConnect встроен)
- **Да, я активный пользователь DeFi каждый день** → **Rabby** или MetaMask

### 3. Беспокоят ли меня мошенники?
- **Да, я слышал страшные истории** → **Lumina Wallet** (трёхуровневый сканер)
- **Я осторожен и разбираюсь в технике** → MetaMask, Rabby или Trust Wallet
- **Я отправляю средства только на известные адреса** → Подойдёт любой кошелёк

## Проблема фейковых токенов: критическое различие

У большинства кошельков из этого списка есть один вопиющий недостаток: они показывают **каждый токен**, который им отправляет блокчейн. Это значит, что когда мошенники делают эйрдроп 10 000 фейковых «USDT» на ваш адрес, MetaMask, Trust Wallet, Rainbow и Coinbase Wallet **отображают их все** так, будто они настоящие.

Если вы нажмёте «продать» — вы подпишете вредоносный контракт. Бум — кошелёк опустошён.

**Lumina Wallet устроен иначе.** Он отображает только токены из **строгого белого списка официальных адресов контрактов для каждого блокчейна**. Фейковый USDT в Ethereum? Игнорируется. Фейковый USDC в BNB Chain? Игнорируется. Одно это устраняет мошенническую схему №1 в крипте 2026 года.

Читайте наше полное руководство: [Фейковые токены — как Lumina блокирует их у источника](/en/security).

## Часто задаваемые вопросы о некастодиальных кошельках

### Какой некастодиальный кошелёк самый безопасный в 2026 году?

Для большинства пользователей — **Lumina Wallet**, потому что он сочетает самостоятельное хранение с активной защитой от мошенников. Для крупных долгосрочных активов — **аппаратный кошелёк Ledger**.

### Можно ли взломать некастодиальный кошелёк?

Сам кошелёк — нет: приватные ключи остаются на вашем устройстве. Но ВАС могут обманом заставить подписать вредоносную транзакцию. Именно поэтому важно выбирать кошелёк со **сканером транзакций**.

### Lumina Wallet действительно бесплатный?

Да. Никаких ежемесячных платежей, никаких премиум-тарифов. Lumina зарабатывает на прозрачных партнёрских комиссиях за дополнительные услуги (стейкинг через Everstake, покупка криптовалюты через MoonPay/Transak) — все они чётко раскрываются.

### Стоит ли использовать несколько кошельков?

Да. Типичная схема серьёзных держателей криптовалюты: **Ledger для накоплений** (>90% активов) + **Lumina Wallet для повседневного использования** (<10%). В каждом кошельке — отдельная seed-фраза.

## Заключение: рынок кошельков повзрослел

В 2026 году одного лишь статуса «некастодиальный» недостаточно. Любой серьёзный кошелёк некастодиальный. **Реальное отличие** — защита от мошенников: насколько хорошо кошелёк оберегает вас в моменты вашей собственной невнимательности?

Наша рекомендация:
- **Обычные пользователи** → [Lumina Wallet](/en/download) (лучшее соотношение безопасности и удобства)
- **Опытные пользователи DeFi** → Rabby или MetaMask
- **Крупные активы** → связка Ledger + Lumina Wallet

**Готовы попробовать самый безопасный некастодиальный кошелёк 2026 года?**

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "permit-malveillant-erc20-scam": {
    title: "Вредоносный ERC-20 Permit: тихая афера, которая опустошает ваш кошелёк без единой транзакции",
    meta: "Узнайте, как работают вредоносные ERC-20 permit и подписи Permit2 — самая опасная крипто-афера 2026 года, опустошающая кошелёк без видимой ончейн-транзакции. Как распознать и заблокировать такие атаки.",
    body: `В 2026 году у пользователей криптовалют было украдено более **$500 миллионов** с помощью одной-единственной техники: **вредоносного ERC-20 permit**. Эта афера особенно опасна тем, что при подписании она не оставляет **никаких видимых ончейн-следов** — лишь неприметную подпись, которая позволяет злоумышленнику опустошить ваш кошелёк в любой момент.

В этом руководстве объясняется, что такое вредоносный permit, почему в 2026 году он стал любимой аферой дрейнеров и, самое главное, **как себя защитить**.

## Что такое ERC-20 Permit?

**Permit** — это расширение стандарта ERC-20, представленное в 2020 году (EIP-2612). Оно позволяет пользователю **дать разрешение** смарт-контракту тратить его токены **без отправки ончейн-транзакции**.

Проще говоря: вместо классической транзакции «Approve», за которую нужно платить комиссию (gas), вы **просто подписываете сообщение** своим кошельком. Затем это сообщение отправляет в сеть сам контракт.

**Законные преимущества:**
- ✅ Экономия на gas (одна транзакция вместо двух)
- ✅ Лучший UX (пользователь подписывает один раз, и всё происходит автоматически)
- ✅ Используется Uniswap, 1inch, DEX-агрегаторами

**Проблема:** эта подпись **незаметна для большинства кошельков**. Вы нажимаете «Подписать», думая, что просто подключаетесь к сайту, — а на деле только что разрешили злоумышленнику вывести 100 000 USDC.

## Как работает афера: 5 шагов

### Шаг 1 — Приманка
Вы переходите по рекламе в Google или по ссылке в Discord на **поддельный Uniswap**, **фальшивую крипто-раздачу (airdrop)** или **фейковый NFT-сайт**. Сайт выглядит на 100% легитимно — официальные логотипы, профессиональный дизайн, обманчивый URL (\`uniswaap.org\` вместо \`uniswap.org\`).

### Шаг 2 — Запрос на подключение
Сайт предлагает «подключить кошелёк». Вы нажимаете, открывается MetaMask, и вы видите лишь «Подписать сообщение». **На первый взгляд** ничего подозрительного.

### Шаг 3 — Скрытое сообщение
Чего вы не видите: сообщение содержит параметры ERC-20 permit:
- **owner**: ваш адрес
- **spender**: адрес злоумышленника
- **value**: максимальная сумма (обычно 115 792 089 237 316 195... = бесконечность)
- **deadline**: 30 дней с текущего момента
- **nonce**: ваш текущий nonce

Вы подписываете. **Сразу** в сети ничего не происходит. Вам кажется, что ничего и не произошло.

### Шаг 4 — Эксплуатация
Спустя часы или дни злоумышленник отправляет **вашу подпись** в сеть через транзакцию \`permit()\` + \`transferFrom()\`. Смарт-контракт принимает её, потому что подпись математически валидна.

### Шаг 5 — Кража
Ваши USDC, USDT, WETH или любые другие ERC-20 токены **переводятся на адрес злоумышленника**. О потере вы узнаёте на следующее утро.

**Вернуть средства невозможно.** Транзакция необратима. Никакие централизованные биржи не задействованы.

## Permit2: усугублённая версия

**Permit2** — расширение, предложенное Uniswap в 2022 году для стандартизации permit для **всех ERC-20 токенов**, даже тех, которые не поддерживают EIP-2612 нативно.

С точки зрения UX в DeFi это **технически блестящее решение**, но для безопасности оно **катастрофично**, потому что:
- Одна подпись Permit2 может разрешить трату **сразу нескольких токенов**
- Подпись остаётся действительной **днями или неделями**
- Большинство кошельков показывают Permit2 как обычное «сообщение» без подробностей

**Результат:** современные дрейнеры в первую очередь используют Permit2, поскольку он делает кражу **более эффективной и менее заметной**.

## Как распознать вредоносный Permit

### Тревожный признак №1: формат подписи
Подпись Permit или Permit2 всегда отображается в вашем кошельке как **типизированное сообщение EIP-712** со следующей структурой:

\`\`\`
Domain: PermitToken or Permit2
Types:
  Permit: [owner, spender, value, nonce, deadline]
Message:
  owner: 0xYOUR_ADDRESS
  spender: 0xUNKNOWN  ← THIS is suspicious
  value: 115792089237316195423570985008687907853269984665640564039457584007913129639935  ← That's infinity!
  deadline: 1735689600
\`\`\`

### Тревожный признак №2: контекст
- Вы только что попали на сайт, которым **никогда раньше не пользовались** → 🔴
- Сайт предлагает **бесплатный airdrop** или **аномально высокую доходность** → 🔴
- Сайт просит подписать сообщение **ещё до того, как показал какой-либо контент** → 🔴
- В URL есть **едва заметная опечатка** (uniswaap вместо uniswap) → 🔴

### Тревожный признак №3: неизвестный spender
Поле \`spender\` (контракт, который будет тратить ваши токены) должно быть **известным и верифицированным** контрактом. Если это случайный адрес, не отображающийся на Etherscan как верифицированный контракт, **это мошенничество.**

## Как Lumina Wallet защищает вас

Lumina Wallet расшифровывает **каждую** подпись Permit и Permit2, прежде чем попросить вас подписать. Вот что происходит на практике:

1. **Расшифровка подписи**: Lumina разбирает сообщение EIP-712 и определяет, является ли оно permit
2. **Проверка spender**: целевой контракт — это известный DEX/протокол (Uniswap, 1inch, Aave...) или неизвестный адрес?
3. **Предупреждение о сумме**: если сумма «бесконечная» (2^256 - 1), появляется критическое предупреждение
4. **Перевод на понятный язык**: вместо шестнадцатеричного набора символов вы видите: *«Вы разрешаете [неизвестному контракту] тратить [все ваши USDC] без ограничений в течение следующих 30 дней»*

Результат: вы видите **ровно то**, что подписываете, до того как подпишете. Подтвердить вредоносный permit по ошибке становится невозможно.

## Что делать, если вы уже подписали вредоносный Permit

### Шаг 1 — Не паникуйте, действуйте быстро
Возможно, permit ещё не использован. У вас есть **временное окно**, пока злоумышленник не применил вашу подпись.

### Шаг 2 — Выведите токены, находящиеся под угрозой
Немедленно переведите все ваши ERC-20 токены на **новый чистый кошелёк**. Используйте свежий кошелёк с новой seed-фразой. Не используйте скомпрометированный кошелёк повторно.

### Шаг 3 — Отзовите существующие разрешения
Перейдите на [revoke.cash](https://revoke.cash) и отзовите все разрешения. **Важное замечание:** revoke.cash НЕ МОЖЕТ отозвать офчейн-подпись Permit, которая ещё не была использована. Вы можете лишь переместить токены.

### Шаг 4 — Сообщите о мошенническом сайте
- ScamAdviser
- Google Safe Browsing
- Chainabuse.com

### Шаг 5 — Откажитесь от скомпрометированного кошелька
Никогда не используйте повторно кошелёк, который подписал вредоносный permit, даже если вы ничего не потеряли. В зависимости от контекста ваш nonce подписи всё ещё может быть использован.

## Мнение экспертов

- **Виталик Бутерин (сооснователь Ethereum)** публично предупреждал о рисках Permit2 в X в 2024 году.
- **Chainalysis** назвала «подписание вредоносного permit» **способом кражи криптовалют №1 в 2025 году**, обогнавшим классические разрешения ERC-20.
- **PeckShield** зафиксировал более 300 атак с вредоносными permit только в 2025 году.

## Заключение: невидимая подпись — новая опасность

Эра видимых ончейн-транзакций закончилась. В 2026 году самая опасная афера не оставляет **никаких видимых следов** в момент подтверждения. Офчейн-подпись — тихая, с отложенным эффектом, — и уже на следующий день ваш кошелёк пуст.

**Единственная эффективная защита:** кошелёк, который **расшифровывает каждую подпись на понятном языке** до того, как вы её подтвердите. Именно это делает Lumina Wallet — для Permit, Permit2 и всех вредоносных подписей EIP-712.

**Защитите себя прямо сейчас:**

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "how-to-set-up-non-custodial-wallet-2026": {
    title: "Как создать некастодиальный криптокошелёк в 2026 году: полное пошаговое руководство",
    meta: "Узнайте, как создать некастодиальный криптокошелёк в 2026 году: полное пошаговое руководство о выборе кошелька, резервном копировании seed-фразы, настройках безопасности и первой транзакции. Подходит для новичков.",
    body: `Создание **некастодиального криптокошелька** — самый важный шаг на вашем пути в мире криптовалют. Сделайте всё правильно, и вы по-настоящему владеете своими средствами: ни банк, ни биржа, ни третьи лица не смогут заморозить или потерять ваши деньги. Сделайте неправильно, и одна ошибка может стоить вам всего.

Это пошаговое руководство проведёт вас через **весь процесс** в 2026 году: от выбора подходящего кошелька до первой безопасной транзакции. Без жаргона и без обходных путей.

## Прежде чем начать: 3 золотых правила

### Правило 1 — Никогда не передавайте свою seed-фразу
Ваша seed-фраза из 12 или 24 слов — это мастер-ключ от всего кошелька. **Ни один добросовестный человек, приложение или сайт никогда не попросит её у вас.** Даже разработчики кошелька, которым вы пользуетесь. Если кто-то просит её, это на 100% мошенничество.

### Правило 2 — Никогда не храните seed-фразу в цифровом виде
Никаких фото. Никаких скриншотов. Никаких заметок в облаке. Никаких менеджеров паролей, подключённых к интернету. Никогда. Запишите её на **бумаге** или выгравируйте на **металле**. Храните бумагу в физически надёжном месте.

### Правило 3 — Всегда скачивайте приложение с официального сайта
Поддельные приложения-кошельки в App Store и Google Play крадут seed-фразы в тот момент, когда вы их вводите. Скачивайте кошелёк только с **официального сайта** (например, https://luminawallet.org), а не из результатов поиска в Google Play или App Store.

## Шаг 1 — Выберите подходящий некастодиальный кошелёк

Для новичков в 2026 году мы рекомендуем **Lumina Wallet**, потому что:
- ✅ Некастодиальный по своей архитектуре (ключи у вас)
- ✅ Встроенный антискам-сканер (защищает вас от ваших собственных ошибок)
- ✅ Мультичейн с первого дня (Bitcoin, Ethereum, Solana, XRP, BNB Chain, Polygon...)
- ✅ Бесплатная загрузка
- ✅ Французская компания (HEDONISME SARL) с прозрачной структурой собственности

Альтернативы в зависимости от вашего профиля:
- **MetaMask** — если вы опытный пользователь DeFi
- **Ledger** — если вы храните более 10 000 € в долгосрочной перспективе (аппаратный кошелёк)
- **Rabby** — если вы ежедневно пользуетесь DeFi в браузере

Читайте наше полное [сравнение лучших некастодиальных кошельков 2026 года](/en/blog/best-non-custodial-crypto-wallet-2026).

## Шаг 2 — Скачайте приложение из официального источника

Для Lumina Wallet:
1. Откройте браузер на телефоне (Safari на iOS, Chrome на Android)
2. Введите **luminawallet.org** напрямую (НЕ ищите через Google — реклама в Google может быть поддельной)
3. Нажмите кнопку **«Download»**
4. Вы будете перенаправлены на официальную страницу в Google Play Store или App Store

Перед установкой проверьте:
- ✅ Имя разработчика: **Lumina Wallet**
- ✅ App Store ID: **id6760651380**
- ✅ Пакет Google Play: **com.luminawallet.app**
- ✅ Количество загрузок > 1 000 (у поддельных клонов их очень мало)

Убедившись в подлинности, установите приложение.

## Шаг 3 — Создайте новый кошелёк (а не импортируйте)

Откройте приложение в первый раз. Вы увидите два варианта:
- **«Create New Wallet»** ← выберите этот
- **«Import Existing Wallet»** ← только если у вас уже есть seed-фраза

Нажмите **Create New Wallet**. Приложение генерирует ваши приватные ключи **локально на вашем устройстве**. Они никогда не попадают на наши серверы, к нашим разработчикам или в интернет.

## Шаг 4 — Сделайте резервную копию seed-фразы (критически важный шаг)

Теперь приложение покажет **12 или 24 слова** в определённом порядке. Это ваша **seed-фраза для восстановления**.

### Как правильно сделать резервную копию:

1. **Возьмите ручку и бумагу** (не телефон).
2. **Запишите слова по порядку**, по одному на строке, с номером рядом с каждым.
3. **Дважды проверьте каждое слово** — одна опечатка означает, что вы не сможете восстановить кошелёк.
4. **Проверьте написание**, сверяя с приложением по одному слову.
5. **Храните бумагу** в физически защищённом месте: в запираемом ящике, домашнем сейфе, банковской ячейке.
6. **Сделайте вторую копию** и храните её **в другом физическом месте** (например, у доверенного члена семьи).
7. **Никогда не фотографируйте** бумагу. Никогда не храните её в «Заметках», iCloud, Google Drive или любом другом облачном сервисе.

**Дополнительный вариант для продвинутых:** выгравируйте seed-фразу на нержавеющей стали (с помощью наборов вроде Cryptosteel, Billfodl или обычного набора металлических штампов). Такая копия устойчива к огню, воде и времени.

### Чего НЕ следует делать:
- ❌ Делать фото «просто для резервной копии»
- ❌ Отправлять её себе по электронной почте
- ❌ Хранить в онлайн-менеджере паролей
- ❌ Сохранять в приложении «Заметки» на телефоне
- ❌ Делиться ею с кем-либо (с супругом, родственниками, «агентами поддержки»)

## Шаг 5 — Подтвердите seed-фразу

Приложение попросит вас **убедиться**, что вы правильно записали фразу. Оно покажет несколько позиций (например, слово №3, слово №7, слово №11) и предложит выбрать правильное слово из списка.

Если вы ошибётесь, приложение вас не заблокирует, но это серьёзный сигнал, что резервная копия сделана неправильно. **Повторите резервное копирование**, пока не сможете подтвердить слова по записям на бумаге.

## Шаг 6 — Установите надёжный пароль для кошелька

Создайте **надёжный пароль** для разблокировки приложения на устройстве:
- Не менее **14 символов**
- Сочетание заглавных и строчных букв, цифр, символов
- **Отличающийся от всех остальных ваших паролей**
- Храните его в менеджере паролей (Bitwarden, 1Password, KeePass)

Этот пароль шифрует ваши ключи локально. Даже если кто-то украдёт ваш телефон, он не сможет открыть Lumina Wallet без этого пароля.

## Шаг 7 — Включите биометрию и PIN-код

В меню настроек кошелька включите:
- ✅ **Face ID** или **отпечаток пальца** (биометрия iOS/Android)
- ✅ **PIN-код** (6 цифр, отличный от PIN-кода разблокировки телефона)

Теперь ваш кошелёк защищают **3 уровня аутентификации**:
1. Разблокировка телефона (Face ID / PIN)
2. PIN-код кошелька (6 цифр)
3. Пароль кошелька (14+ символов)

Даже если вор украдёт ваш разблокированный телефон, он не получит доступ к вашей криптовалюте.

## Шаг 8 — Проверьте всё с помощью небольшой тестовой транзакции

Прежде чем хранить сколько-нибудь значительную сумму:

1. Отправьте себе криптовалюту **на сумму от 5 € до 10 €** с биржи (Coinbase, Binance, Kraken) на адрес нового кошелька.
2. Дождитесь подтверждения транзакции (обычно от 1 до 15 минут в зависимости от блокчейна).
3. Отправьте её **обратно** на биржу в качестве ещё одного теста.

Если обе операции прошли успешно, ваш кошелёк настроен правильно. **Не храните крупные суммы, пока не выполните этот тест.**

## Шаг 9 — Потренируйтесь с антискам-сканером

В Lumina Wallet есть встроенный сканер, который защищает от распространённых мошеннических схем. Испытайте его:

- **Попробуйте отправить средства на заведомо поддельный адрес** (например, 0x000...000) → Lumina заблокирует операцию
- **Попробуйте отсканировать QR-код, не связанный с криптовалютой** → Lumina отклонит его
- **Изучите предварительный просмотр транзакции** перед подписанием → Lumina показывает точный список токенов, которые уходят с кошелька

Если вы познакомитесь с этими предупреждениями **сейчас**, вы узнаете их, когда столкнётесь с настоящим мошенничеством.

## Шаг 10 — Только теперь храните реальные суммы

Когда вы:
- ✅ Подтвердили резервную копию seed-фразы
- ✅ Настроили биометрию, PIN-код и пароль
- ✅ Успешно выполнили тестовую транзакцию
- ✅ Потренировались со сканером

...**тогда** можно начинать хранить реальные суммы.

Рекомендуемая схема для серьёзных держателей:
- **Повседневный кошелёк**: держите здесь <10 % от общего объёма вашей криптовалюты (для трат, DeFi, обменов)
- **Сберегательное хранилище**: для крупных сумм используйте аппаратный кошелёк (Ledger) с другой seed-фразой, хранящейся офлайн

## Распространённые ошибки, подрывающие безопасность кошелька

Даже пользователи, следующие этому руководству, иногда совершают такие ошибки. Избегайте их:

- ❌ **Скриншот seed-фразы** «просто для резервной копии» — iCloud синхронизирует его с облаком
- ❌ **Повторное использование одного и того же пароля** для кошелька и электронной почты
- ❌ **Переход по рекламе Google** при поиске приложений-кошельков (поддельные клоны используют рекламу Google)
- ❌ **Игнорирование предупреждений безопасности**, потому что вы торопитесь
- ❌ **Подключение к случайным DApp** ради «проверки» airdrop

## Часто задаваемые вопросы о создании некастодиального кошелька

### Сколько времени занимает создание некастодиального кошелька?

Если следовать этому руководству внимательно, примерно **15–20 минут**. Большая часть времени уходит на то, чтобы правильно записать и проверить seed-фразу.

### Безопасно ли вводить seed-фразу на телефоне?

Только в **одном случае**: когда вы создаёте НОВЫЙ кошелёк или восстанавливаете существующий **внутри официального приложения кошелька**. Никогда не вводите её на сайте, в чате поддержки или в любом другом приложении.

### Можно ли использовать одну и ту же seed-фразу для нескольких кошельков?

Да. Ваша seed-фраза — это мастер-ключ: вы можете импортировать её в любой кошелёк, совместимый с BIP-39 (Lumina, MetaMask, Trust Wallet, Ledger...), и получить доступ к тем же аккаунтам. Однако лучшая практика — **использовать разные seed-фразы для разных целей** (повседневный кошелёк и сбережения).

### Что делать, если я потеряю телефон?

Если у вас есть записанная seed-фраза: установите Lumina Wallet на новый телефон, выберите «Import Existing Wallet», введите seed-фразу — ваши средства мгновенно вернутся к вам.

Если у вас нет записанной seed-фразы: ваша криптовалюта **потеряна навсегда**. Без исключений.

## Заключение: настройте правильно — и спите спокойно

Создание некастодиального кошелька — это **единовременная инвестиция**, которая определяет безопасность вашей криптовалюты на долгие годы. Потратьте дополнительные 5 минут, чтобы правильно записать seed-фразу, включите все уровни защиты и сначала протестируйте всё на небольших суммах.

**Lumina Wallet** создан, чтобы сделать этот процесс максимально безопасным — с антискам-сканером, который ловит ошибки, которые вы можете совершить позже, как бы осторожны вы ни были сегодня.

**Готовы создать свой первый некастодиальный кошелёк?**

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "unhosted-wallet-vs-custodial-wallet": {
    title: "Unhosted-кошелёк и кастодиальный кошелёк: регуляторный гид на 2026 год",
    meta: "Что такое «unhosted-кошелёк»? Разбираемся в разнице между unhosted- и кастодиальными кошельками (так Минфин США называет некастодиальные кошельки) и в том, что это значит для регулирования криптовалют, приватности и самостоятельного хранения в 2026 году.",
    body: `Если вы читали недавние публикации Минфина США или FinCEN, вы наверняка встречали термин **«unhosted wallet»** («неразмещённый кошелёк»). Это регуляторное название того, что крипто-сообщество называет **некастодиальным кошельком**, но с тонкими нюансами, которые важны в 2026 году. В этом руководстве мы объясним, что такое unhosted-кошелёк, чем он отличается от кастодиального и почему терминология важна для приватности, комплаенса и самостоятельного хранения активов.

## Что такое unhosted-кошелёк?

**Unhosted-кошелёк** — это криптовалютный кошелёк, в котором приватными ключами управляет пользователь, а не сторонний поставщик услуг. На языке финансовых регуляторов США, в первую очередь FinCEN (Financial Crimes Enforcement Network, Сеть по борьбе с финансовыми преступлениями) и Минфина США, «unhosted» означает: **не размещён у регулируемого финансового учреждения**.

**Конкретно, unhosted-кошелёк — это:**
- ✅ Кошелёк, в котором приватные ключи храните **вы**
- ✅ Кошелёк, которым не управляет банк, биржа или любой зарегистрированный поставщик денежных услуг (Money Services Business, MSB)
- ✅ Кошелёк, доступ к которому не требует прохождения KYC

**Распространённые синонимы в 2026 году:**
- Некастодиальный кошелёк (отраслевой термин)
- Кошелёк для самостоятельного хранения (образовательный термин)
- Личный кошелёк (неформальный термин)

## Unhosted и кастодиальные кошельки: ключевые различия

| Характеристика | Unhosted-кошелёк | Кастодиальный кошелёк |
|---|---|---|
| **Кто хранит приватные ключи?** | Вы | Регулируемая третья сторона (биржа, банк) |
| **Требуется ли KYC?** | Нет | Да (верификация личности) |
| **Можно ли заморозить аккаунт?** | Нет — ни у кого нет такой власти | Да — кастодиан может заморозить по запросу |
| **Регуляторная отчётность?** | Ограниченная (зависит от юрисдикции) | Полная (каждая транзакция передаётся властям) |
| **Кто юридически владеет средствами?** | Непосредственно вы | Кастодиан хранит их для вас |
| **Риск банкротства?** | Отсутствует | Есть — вы необеспеченный кредитор |
| **Примеры** | Lumina Wallet, MetaMask, Ledger | Coinbase, Binance, Kraken (стандартный аккаунт) |

## Почему регуляторы используют термин «unhosted»

Термин «unhosted» стал широко известен благодаря **проекту правила FinCEN в декабре 2020 года**, которое обязывало бы биржи собирать идентификационные данные по транзакциям с unhosted-кошельками и на них при превышении определённых порогов.

Это правило:
- **Не было принято в первоначальном виде** (из-за сильного сопротивления отрасли)
- Частично реализовано в **американской системе отчётности по криптоактивам 2024 года (Crypto-Asset Reporting Framework)**
- Часть более широкой гармонизации G7/FATF по **Travel Rule** для криптовалют

В 2026 году «unhosted wallet» чаще всего используется в:
- публикациях Минфина США и FinCEN
- рекомендациях FATF (Financial Action Task Force, Группа разработки финансовых мер борьбы с отмыванием денег)
- европейском регламенте MiCA (Markets in Crypto-Assets)
- выступлениях в Конгрессе по криптовалютной политике

## Законно ли использовать unhosted-кошелёк?

**Да.** Использование unhosted-кошелька **полностью законно** в США, Европейском союзе, Великобритании, Франции и практически во всех демократических странах в 2026 году.

Регулируются:
- Транзакции **между биржами и unhosted-кошельками** (с учётом порогов отчётности)
- Отдельные виды деятельности с unhosted-кошельками (денежные переводы, услуги хранения)
- **Не** регулируется само владение unhosted-кошельком или его использование физическим лицом

Чтобы было предельно ясно: **в 2026 году вы можете на законных основаниях владеть unhosted-кошельком во Франции и ЕС, пользоваться им, отправлять с него и получать на него криптовалюту — без какой-либо лицензии или разрешения.**

## Компромисс в отношении приватности

Unhosted-кошельки обеспечивают **больше приватности**, чем кастодиальные, потому что:
- Для создания не требуется KYC
- Транзакции не передаются в центральные органы
- Посредники не могут блокировать транзакции

Однако эта приватность **не абсолютна**:
- Транзакции в блокчейне **публично видны навсегда**
- Если ваша личность связана с вашим адресом (через биржи, dApps, KYC-события), вся ваша ончейн-история становится отслеживаемой
- **Компании, занимающиеся анализом блокчейна** (Chainalysis, Elliptic, TRM Labs), активно отслеживают активность в сети

Для реальной приватности в 2026 году вам понадобятся:
- Unhosted-кошелёк
- Осторожное использование бирж (по возможности — шлюзы «наличные — крипта»)
- Инструменты, ориентированные на приватность (миксеры, приватные монеты или ZK-протоколы приватности)

⚠️ **Примечание:** Регулирование инструментов приватности меняется. Для крупных сумм или бизнес-использования проконсультируйтесь с местным юристом.

## Unhosted-кошельки и MiCA (Европа)

**Регламент ЕС MiCA** (Markets in Crypto-Assets), полностью действующий с декабря 2024 года, регулирует unhosted-кошельки следующим образом:

- **Физические лица** могут свободно использовать unhosted-кошельки — отчётность не требуется
- **Поставщики услуг в сфере криптоактивов (CASP)** — биржи, кастодианы — обязаны собирать идентификационные данные по транзакциям свыше **1 000 €** на unhosted-кошельки и с них («Travel Rule»)
- Транзакции между unhosted-кошельками физических лиц остаются **нерегулируемыми**

На практике: французский пользователь может свободно пользоваться Lumina Wallet, получать на него криптовалюту и отправлять с него — без каких-либо особых обязательств.

## Безопасность unhosted-кошелька: что нужно знать

Поскольку unhosted-кошельки дают вам полный контроль, они же накладывают и **полную ответственность**:

### Плюсы:
- ✅ **Никакая третья сторона** не может заморозить ваши средства
- ✅ **Банкротство кастодиана** не приведёт к потере ваших средств
- ✅ **Полная приватность** по умолчанию
- ✅ **Прямой доступ к DeFi** без посредников

### Обратная сторона:
- 🔴 **Потеряли seed-фразу — потеряли средства** (кнопки «забыл пароль» нет)
- 🔴 **Попались на фишинг — потеряли средства** (отмена невозможна)
- 🔴 **Подписали вредоносный контракт — потеряли средства** (ответственность полностью на вас)

Поэтому выбор unhosted-кошелька со **встроенной защитой от мошенничества**, такого как Lumina Wallet, заметно улучшает баланс риска и выгоды. Вы сохраняете свободу самостоятельного хранения и получаете подстраховку от собственных ошибок.

## Стоит ли использовать unhosted-кошелёк?

**Да, если:**
- Вы хотите по-настоящему владеть своей криптовалютой
- Вы серьёзно настроены на долгосрочное хранение
- Вы хотите пользоваться DeFi, NFT или Web3-приложениями
- Вас беспокоит банкротство биржи или заморозка аккаунта
- Вы цените приватность

**Нет, если:**
- Вы лишь изредка торгуете на централизованных биржах
- Вам неудобно управлять seed-фразой
- Вам нужна страховка «забыл пароль», как в кастодиальных сервисах
- Простота регуляторной отчётности для вас важнее самостоятельного хранения

Для большинства серьёзных пользователей криптовалют ответ такой: **используйте оба варианта**. Держите средства для активной торговли на регулируемой бирже, а долгосрочные накопления переводите в unhosted-кошелёк.

## FAQ: unhosted-кошельки

### «Unhosted wallet» — это то же самое, что «холодный кошелёк»?

Не совсем. **«Unhosted»** описывает, кто контролирует ключи (вы, а не третья сторона). **«Холодный»** описывает, где хранятся ключи (офлайн или онлайн). Кошелёк может быть unhosted И горячим (Lumina, MetaMask) либо unhosted И холодным (Ledger, Trezor).

### Нужно ли декларировать unhosted-кошелёк в налоговой декларации?

Во Франции с 2020 года необходимо декларировать **зарубежные счета цифровых активов** по форме 3916-BIS. Unhosted-кошельки, которыми вы владеете напрямую (без кастодиана), как правило, **не подпадают под это обязательство**, но правила отчётности меняются. Проконсультируйтесь с налоговым специалистом применительно к вашей ситуации.

### Может ли государство изъять криптовалюту из unhosted-кошелька?

Только если у него есть приватные ключи или если оно заставит вас передать их в рамках судебной процедуры. Известны случаи, когда власти изымали криптовалюту, получив seed-фразы по ордеру на обыск или в рамках сделки со следствием. **Криптографическое владение — это не то же самое, что юридический иммунитет.**

### Какой unhosted-кошелёк лучше всего подходит для новичков?

**Lumina Wallet** создан специально для тех, кто хочет самостоятельно хранить активы, не становясь экспертом по криптовалютам. Встроенная защита от мошенничества отлавливает самые распространённые ошибки, а поддержка нескольких сетей (Bitcoin, Ethereum, Solana, XRP, BNB, Polygon...) покрывает всё, что вам реально может понадобиться.

## Заключение

«Unhosted wallet» — это слово регулятора для **некастодиального кошелька**, фундаментального инструмента владения криптовалютой в 2026 году. Понимание этого термина поможет вам ориентироваться в политических дебатах, налоговой отчётности и комплаенсе в эпоху MiCA.

Главное: unhosted-кошельки **законны, мощны и никуда не денутся**. Выберите тот, что сочетает самостоятельное хранение с практической защитой, например Lumina Wallet, и получите лучшее из обоих миров.

**Готовы попробовать современный unhosted-кошелёк?**

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "non-custodial-wallet-app-2026-mobile-guide": {
    title: "Некастодиальное кошелёк-приложение: полное руководство на 2026 год для мобильных пользователей",
    meta: "Ищете лучшее некастодиальное кошелёк-приложение в 2026 году? Полное руководство для мобильных устройств: чего ожидать, обязательные меры безопасности, сравнение топ-5 приложений для iOS/Android и как распознать поддельные клоны в App Store.",
    body: `Поиск **некастодиального кошелька-приложения** в 2026 году — задача непростая. В App Store и Google Play сотни приложений, и каждое называет себя самым безопасным, самым удобным или самым функциональным. Некоторые действительно превосходны. Другие — откровенное мошенничество (поддельные клоны, созданные для кражи seed-фраз). Это руководство полностью посвящено мобильным устройствам — без браузерных расширений и аппаратных кошельков — и содержит практический подход к выбору подходящего приложения И к тому, как обойти ловушки.

## Что такое некастодиальное кошелёк-приложение?

**Некастодиальное кошелёк-приложение** — это мобильное приложение (iOS или Android), в котором:
- **Вы** владеете приватными ключами — они зашифрованы локально на вашем телефоне
- **Ни биржа, ни банк, ни третья сторона** не могут заморозить или потерять ваши криптоактивы
- **Ваша seed-фраза** генерируется локально и никогда не покидает устройство
- Доступ защищён биометрией + PIN-кодом + паролем

Лучшие мобильные некастодиальные кошельки 2026 года поддерживают более 10 блокчейнов, интегрируются с Web3-приложениями через WalletConnect и — что крайне важно — имеют **защиту от мошенничества**, встроенную прямо в приложение.

## Почему в 2026 году мобильные устройства важнее десктопа

Более **72% криптотранзакций** в 2026 году совершаются на мобильных устройствах (Chainalysis 2026 State of Crypto). Мобильные некастодиальные кошельки обогнали браузерные расширения, потому что:

- 🔐 В современных телефонах есть **аппаратные модули безопасности** (iOS Secure Enclave, Android Keystore), с которыми браузеры не сравнятся
- 📱 **Биометрическая аутентификация** (Face ID, отпечаток пальца) стала стандартом
- 🚀 **Push-уведомления** мгновенно сообщают о входящих транзакциях
- 📷 **Камера и сканирование QR-кодов** делают ввод адреса безопаснее
- 🌐 **WalletConnect v2** позволяет мобильным кошелькам подписывать операции для десктопных dApp

## Топ-5 некастодиальных кошельков-приложений 2026 года

### 🥇 Lumina Wallet — лучший мобильный кошелёк с упором на безопасность
- **Платформы:** iOS + Android
- **Сети:** Bitcoin, Ethereum, Solana, XRP, BNB Chain, Polygon, Arbitrum, Optimism, Base, Avalanche
- **Уникальные возможности:** трёхуровневый антискам-сканер (считыватель QR-кодов, аудит адресов, декодер транзакций) + [фильтр поддельных токенов на основе белого списка](/en/security)
- **Подходит для:** тех, кто хочет максимальную защиту, не становясь экспертом по криптовалютам
- **Бесплатно** — без подписки

### 🥈 Trust Wallet — самая широкая поддержка сетей
- **Платформы:** iOS + Android
- **Сети:** 70+
- **Недостаток:** по умолчанию показывает все токены (риск спама поддельными токенами), базовая защита от мошенничества
- **Подходит для:** пользователей, активных во множестве малоизвестных сетей

### 🥉 MetaMask Mobile — стандарт DeFi
- **Платформы:** iOS + Android
- **Сети:** EVM-сети, Solana и Bitcoin
- **Недостаток:** базовые предупреждения, нет фильтра поддельных токенов, исторически неудобный UX
- **Подходит для:** тех, кто уже знаком с MetaMask в браузере

### Rainbow — лучший UX для Ethereum
- **Платформы:** iOS + Android
- **Сети:** только экосистема Ethereum
- **Недостаток:** ограниченная мультичейн-поддержка
- **Подходит для:** обычных пользователей Ethereum, ценящих дизайн

### Coinbase Wallet — лучший выбор для пользователей Coinbase
- **Платформы:** iOS + Android
- **Сети:** 20+
- **Недостаток:** базовая защита от мошенничества, опасения по поводу сбора данных
- **Подходит для:** тех, кто переходит с биржи Coinbase на самостоятельное хранение

## 4 обязательные функции в 2026 году

При сравнении некастодиальных кошельков-приложений требуйте ВСЕ ЧЕТЫРЕ:

### 1. Локальное хранение ключей с аппаратной защитой
Приватные ключи должны шифроваться с помощью iOS Secure Enclave или Android Keystore. **Если приложение хранит ключи в открытом виде или синхронизирует их с облаком — уходите.**

### 2. Встроенный антискам-сканер
Любой кошелёк 2026 года, достойный своего названия, должен:
- Проверять адреса получателей по спискам известных мошеннических адресов
- Расшифровывать подписи ERC-20 Permit / Permit2 простым языком
- Симулировать транзакции перед подписанием (показывает, какие именно токены уйдут)
- Предупреждать о схемах «неограниченного разрешения» (unlimited approval)

### 3. Фильтр поддельных токенов
Это **главное отличие 2026 года**. Мошенники рассылают 10 000 поддельных токенов «USDT» миллионам кошельков. Кошельки, которые показывают каждый токен, опасны. Ищите кошельки, использующие **белый список официальных адресов контрактов для каждого блокчейна** (сейчас лидер здесь — Lumina).

### 4. Мультичейн с первого дня
Одна seed-фраза должна генерировать адреса для Bitcoin, Ethereum, Solana, XRP, BNB Chain и других крупных сетей. Никакой необходимости жонглировать несколькими приложениями.

## Как распознать поддельные кошельки в App Store

**Поддельные клоны** — серьёзная угроза в 2026 году. Они копируют название, логотип и описание Lumina Wallet, а затем крадут вашу seed-фразу в тот момент, когда вы её вводите.

**Контрольный список перед загрузкой:**

- ✅ Скачивайте только с **официального сайта** (например, https://luminawallet.org). Никогда не ищите в App Store.
- ✅ Убедитесь, что **имя разработчика** совпадает в точности (Lumina Wallet опубликован под именем *Lumina Wallet*)
- ✅ Проверьте **ID пакета**: настоящий Lumina = \`com.luminawallet.app\`
- ✅ Проверьте **ID в App Store**: настоящий Lumina = \`id6760651380\`
- ✅ Число загрузок > 1 000 (у поддельных клонов обычно < 100)
- ✅ Читайте отзывы — у клонов часто подозрительно однотипные 5-звёздочные отзывы

📖 Читайте наше полное руководство: [Поддельные клоны криптокошельков](/en/blog/fake-crypto-wallet-clones)

## FAQ о некастодиальных кошельках-приложениях

### Некастодиальное кошелёк-приложение безопаснее, чем приложение биржи?

Для среднесрочного и долгосрочного хранения — **да**. Некастодиальный кошелёк невозможно взломать на уровне платформы: у каждого пользователя свои ключи на своих устройствах. Приложения бирж — это «медовые горшки», на которые постоянно нацелены злоумышленники.

### Платные ли некастодиальные кошельки-приложения?

Лучшие в своём классе приложения, такие как **Lumina Wallet**, полностью бесплатны. Некоторые кошельки зарабатывают на прозрачных партнёрских комиссиях за дополнительные услуги (стейкинг, покупка криптовалюты). Остерегайтесь приложений, требующих «премиум-подписку» за базовые функции кошелька.

### Можно ли использовать одно и то же некастодиальное кошелёк-приложение на нескольких телефонах?

Да — установите приложение на оба телефона и импортируйте seed-фразу на каждом. Оба телефона будут показывать одинаковые балансы и смогут независимо отправлять транзакции. Будьте осторожны: любой телефон с вашей seed-фразой имеет полный доступ.

### Что будет, если разработчик кошелька-приложения исчезнет?

Ваши криптоактивы останутся в безопасности. Некастодиальность означает, что приложение — всего лишь интерфейс, а ваши активы находятся в блокчейне. Если Lumina Wallet когда-нибудь исчезнет, вы сможете импортировать seed-фразу в **любой кошелёк, совместимый с BIP-39** (MetaMask, Trust Wallet, Ledger…) и полностью восстановить доступ.

## Заключение: выберите кошелёк-приложение, которому будете доверять годами

Ваше некастодиальное кошелёк-приложение — это то место, где вы будете взаимодействовать со своими криптоактивами **сотни раз** в ближайшие годы. Выберите то, которое сочетает самостоятельное хранение с активной защитой от угроз 2026 года — вредоносных подписей, поддельных токенов, фишинговых адресов.

**Lumina Wallet** создан именно для этого: мобильный некастодиальный кошелёк с трёхуровневым антискам-сканером, отображением токенов только с официальными контрактами и поддержкой более 10 блокчейнов. Бесплатный, прозрачный (французская компания HEDONISME SARL, RCS Dunkerque 901 439 505), без сбора данных.

**Готовы попробовать самое безопасное некастодиальное кошелёк-приложение 2026 года?**

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "metamask-vs-lumina-wallet-anti-scam-comparison": {
    title: "MetaMask против Lumina Wallet: сравнение защиты от мошенничества в 2026 году",
    meta: "MetaMask или Lumina Wallet в 2026 году? Предельно честное сравнение с фокусом на защиту от мошенников: фильтр поддельных токенов, расшифровка подписей, сканер адресов, поддержка нескольких блокчейнов и удобство мобильного приложения.",
    body: `**MetaMask** — самый популярный в мире некастодиальный кошелёк, у которого более 30 миллионов активных пользователей в месяц. **Lumina Wallet** — более новый мобильный кошелёк, созданный специально для защиты от мошенничества. Какой из них выбрать в 2026 году? В этом сравнении мы сосредоточимся на самом важном для современного крипторынка: насколько хорошо каждый кошелёк защищает вас от опустошения.

## Краткий ответ

- **Выбирайте MetaMask, если:** вы опытный пользователь DeFi, работаете в браузере и умеете читать вызовы функций Solidity перед подписанием.
- **Выбирайте Lumina Wallet, если:** вам нужен мобильный кошелёк, который распознаёт мошенничество за вас — до того, как вы совершите дорогостоящую ошибку.

Для большинства пользователей в 2026 году ответ — **Lumina Wallet**. Вот почему.

## Сравнение бок о бок

| Функция | MetaMask | Lumina Wallet |
|---|---|---|
| **Платформа** | Браузер + мобильное приложение | Только мобильное (iOS + Android) |
| **Поддерживаемые сети** | EVM-сети, Solana и Bitcoin | 10+, включая BTC, ETH, SOL, XRP, BNB |
| **Хранение ключей** | Хранилище браузера / Mobile Keystore | iOS Secure Enclave / Android Keystore |
| **Антискам-сканер адресов** | ⚠️ Базовый (только список блокировок) | ✅ GoPlus в реальном времени + собственный сканер |
| **Фильтр поддельных токенов** | ❌ Показывает все токены | ✅ Белый список по официальным контрактам |
| **Декодер ERC-20 Permit** | ⚠️ Показывает сырые hex-данные | ✅ Перевод на понятный язык |
| **Декодер Permit2** | ⚠️ Базовый | ✅ Полная расшифровка с проверкой суммы и spender |
| **Симуляция транзакций** | ⚠️ Базовая (только Ethereum) | ✅ Симуляция в нескольких сетях |
| **Адресная книга (защита от опечаток)** | ❌ Нет | ✅ Да |
| **Открытый исходный код** | ✅ Да | ⚠️ Пока нет (в планах) |
| **Прозрачность компании** | ⚠️ Consensys (США) | ✅ HEDONISME SARL (Франция) — проверяемо через RCS |
| **Стоимость** | Бесплатно | Бесплатно |

## Главное отличие: фильтр поддельных токенов

В 2026 году **мошенничество №1 в крипте** — вредоносные эйрдропы. Мошенники создают поддельные токены USDT, USDC или WETH с тем же названием и логотипом, что и настоящие, а затем рассылают по 10 000 таких токенов миллионам кошельков. Когда вы пытаетесь их продать, вы подписываете вредоносный контракт → ваш кошелёк опустошён.

### Как с этим справляется MetaMask
MetaMask показывает **каждый токен**, который отправляет вам блокчейн. Если кто-то отправит поддельный USDT на ваш адрес, он появится в кошельке — с идентичным названием и логотипом. Чтобы убедиться в подлинности, нужно вручную проверить адрес контракта на Etherscan. Большинство пользователей этого не делают.

### Как с этим справляется Lumina Wallet
Lumina использует **строгий белый список официальных адресов контрактов для каждого блокчейна**. Отображается только USDT из настоящего контракта Ethereum (0xdAC17F...). Поддельные токены невидимы. Никаких действий от пользователя не требуется.

Читайте наш подробный разбор: [Как Lumina блокирует поддельные токены на уровне источника](/en/security)

## Расшифровка подписей: тихая защита от мошенничества

Вредоносные подписи ERC-20 Permit и Permit2 обошлись пользователям **более чем в $500 млн в 2026 году** (см. наше [полное руководство](/en/blog/malicious-erc20-permit-scam)). Они работают, потому что большинство кошельков показывают подписи в виде непонятных hex-данных — пользователи не понимают, что именно подписывают.

### MetaMask и подписи
MetaMask показывает подписи Permit как отформатированное сообщение EIP-712, но детали остаются техническими. Поля вроде \`spender\`, \`value\`, \`nonce\` видны, но не объяснены. Обычные пользователи регулярно пропускают предупреждения о «неограниченном разрешении».

### Lumina Wallet и подписи
Lumina **расшифровывает каждую подпись** простым языком, прежде чем предложить вам подписать:
- «Вы разрешаете [название контракта / неизвестный контракт] потратить [сумма / НЕОГРАНИЧЕННО] вашего [токен] на срок [длительность]»
- Критические предупреждения при неограниченных суммах
- Красный флаг, если spender — не проверенный контракт

Практический результат: вы точно понимаете, что подписываете, ещё до подписания.

## Поддержка нескольких блокчейнов

MetaMask изначально был **кошельком для Ethereum**. С 2025 года он также нативно поддерживает Solana и Bitcoin благодаря мультичейн-аккаунтам ([MetaMask](https://metamask.io/news/multichain-accounts)). XRP нативно не поддерживается, а сети вне встроенного списка по-прежнему нужно добавлять вручную — небольшое неудобство для новичков.

Lumina Wallet **с первого дня работает с несколькими блокчейнами**: Bitcoin, Ethereum, Solana, XRP, BNB Chain, Polygon, Arbitrum, Optimism, Base, Avalanche. Одна seed-фраза, одно приложение, всё работает.

## Пользовательский опыт: реальность мобильных устройств

**Правда:** мобильное приложение MetaMask годами критикуют за неповоротливый интерфейс, медленный браузер dApp и проблемы с подключением через WalletConnect. Версия 8.0 (2026) кое-что улучшила, но дизайн по-прежнему заметно отстаёт от кошельков, создаваемых в первую очередь для мобильных устройств.

**Lumina Wallet** изначально создавался как мобильное приложение, и в нём есть:
- Мгновенный предпросмотр транзакций
- Биометрическая разблокировка
- Чистый современный интерфейс, разработанный мобильными UX-дизайнерами
- Нативная поддержка WalletConnect v2

## Где MetaMask выигрывает

MetaMask никуда не уходит. Его сильные стороны в 2026 году:

- ✅ **Доминирование в экосистеме**: в 99% dApp «Connect with MetaMask» — вариант по умолчанию
- ✅ **Расширение для браузера**: лучше подходит для опытных пользователей DeFi, работающих преимущественно на десктопе
- ✅ **Экосистема Snaps**: расширяемость за счёт сторонних плагинов
- ✅ **Открытый исходный код**: код публичен и доступен для аудита

Если вы опытный пользователь DeFi и придерживаетесь дисциплины холодного хранения, MetaMask вам подойдёт. Но баланс между безопасностью и удобством в 2026 году сместился, и именно к Lumina идут массовые пользователи.

## MetaMask против Lumina Wallet: FAQ

### Можно ли использовать оба кошелька?

Да — многие так и делают. Типичная схема: MetaMask на десктопе для продвинутых задач DeFi, Lumina Wallet на мобильном устройстве для ежедневных транзакций и любых подписей в условиях спешки.

### Совместима ли seed-фраза между ними?

Да. Оба используют стандарт BIP-39, поэтому вы можете импортировать одну и ту же seed-фразу в любой из кошельков и получить доступ к тем же аккаунтам.

### Какой из них безопаснее?

Для **базового хранения ключей**: оба безопасны (некастодиальные, шифруют данные локально). Для **активной защиты от мошенничества**: Lumina Wallet в 2026 году значительно впереди благодаря фильтру поддельных токенов, декодеру подписей и мультичейн-сканеру.

### Какой из них быстрее?

Оба быстры при обычных транзакциях. При взаимодействии с dApp браузерное расширение MetaMask быстрее на десктопе. Мобильное приложение Lumina Wallet быстрее, чем MetaMask Mobile.

## Вывод: разные кошельки для разных пользователей

MetaMask остаётся отраслевым стандартом для опытных пользователей DeFi, для которых важны совместимость с экосистемой и открытый код. Lumina Wallet — современный ответ для тех, кто ставит на первое место **защиту от угроз 2026 года**: вредоносных подписей, поддельных токенов и фишинговых адресов.

Если вы когда-нибудь нервничали, нажимая «Подписать», не до конца понимая, что делает транзакция, **Lumina Wallet создан для вас**.

**Готовы попробовать антискам-кошелёк 2026 года?**

[Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [Скачать в App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "guide-wallet-non-custodial-2026": {
    title: "Некастодиальный криптокошелёк: полное руководство 2026 года",
    meta: "Что такое некастодиальный криптокошелёк в 2026 году, чем он отличается от кастодиальных бирж, как его выбрать и какой чек-лист безопасности нужно выполнить, прежде чем переводить хотя бы один сатоши. Руководство для обычных пользователей.",
    body: `**Некастодиальный криптокошелёк** — это кошелёк, в котором **только вы владеете приватными ключами**, управляющими вашими средствами. Ни компания, ни биржа, ни любая третья сторона не может заморозить, конфисковать или потерять ваши активы вместо вас. В 2026 году, после десятилетия крахов бирж (FTX, Celsius, Mt. Gox) и миллиардов долларов замороженных пользовательских средств, некастодиальные кошельки из нишевого выбора превратились в рекомендацию по умолчанию почти для всех исследователей безопасности [1].

В этом руководстве простым языком объясняется, как работают некастодиальные кошельки, чем они отличаются от кастодиальных решений, на какие компромиссы вы соглашаетесь при самостоятельном хранении и как с помощью практического чек-листа 2026 года выбрать кошелёк, которому можно действительно доверять.

## Определение 2026 года: что такое некастодиальный кошелёк

Криптокошелёк — это всего лишь инструмент для управления **приватными ключами**: длинными криптографическими строками, подтверждающими право собственности на монеты, записанные в блокчейне. Существуют две модели хранения:

| Модель | Кто хранит ключи? | Кто может перемещать ваши средства? | Пример |
|---|---|---|---|
| **Кастодиальная** | Компания (биржа, брокер) | Компания (и вы — через неё) | Coinbase, Binance, Revolut Crypto |
| **Некастодиальная** | Вы (на своём устройстве) | Только вы | Lumina Wallet, MetaMask, Phantom, Ledger |

В некастодиальной схеме ключи генерируются **локально на вашем телефоне или аппаратном устройстве** и шифруются с помощью защищённого хранилища операционной системы (iOS Secure Enclave, Android Keystore или специального чипа в аппаратном кошельке). Приложение кошелька никуда их не передаёт. Если компания, создавшая кошелёк, завтра исчезнет, ваши средства останутся доступными, пока у вас есть **фраза восстановления из 12 или 24 слов** (BIP-39).

## Почему 2026 год стал годом самостоятельного хранения

Три фактора сделали некастодиальные кошельки массовыми в 2026 году:

1. **Крахи бирж больше не редкость.** По данным Chainalysis, $2.8B пользовательских средств до сих пор заморожены или потеряны в результате крахов бирж в 2022–2025 годах [2].
2. **MiCA и мировое регулирование подталкивают к доказательству резервов.** Но доказательство резервов не защищает от операционной неплатёжеспособности — защищает только самостоятельное хранение.
3. **Мобильные кошельки подтянулись по удобству.** Разрыв в удобстве между открытием аккаунта на Binance и настройкой некастодиального кошелька сократился до менее чем 5 минут.

## Реальные компромиссы (честная версия)

Выбор некастодиального кошелька — не строго «лучшее» решение, а другая модель ответственности. Вот честный баланс:

**Что вы получаете:**
- Прямое владение — никакого контрагентского риска
- Доступ к DeFi, NFT, обменам и стейкингу без KYC при каждом действии
- Устойчивость к цензуре
- Более низкие комиссии в долгосрочной перспективе (без кастодиального спреда)

**На что вы соглашаетесь:**
- **Вы сами — резервная копия.** Потеряете фразу из 24 слов — никакая служба поддержки не вернёт ваши средства.
- **Вы сами — служба безопасности.** Фишинг, вредоносные подписи, поддельные токены — кошелёк помогает, но окончательное решение принимаете вы.
- **Нет возврата при мошенничестве.** Транзакции в блокчейне необратимы.

Нагрузку по безопасности можно существенно снизить, выбрав кошелёк с **активной защитой от мошенничества** (расшифровка подписей, проверка адресов, фильтрация поддельных токенов). Но полностью она не исчезает никогда.

## Как выбрать некастодиальный кошелёк в 2026 году

Не все некастодиальные кошельки одинаковы. Маркетинговые заявления («безопасный», «самый защищённый кошелёк») не являются критериями оценки. Используйте этот конкретный чек-лист:

### 1. Хранение ключей: где живёт seed-фраза?

- **Минимально допустимый уровень (программные кошельки):** ключи хранятся в iOS Secure Enclave или Android Keystore и защищены биометрией или PIN-кодом. Ни в коем случае не в открытом хранилище приложения и не в облачной синхронизации.
- **Максимальная безопасность:** аппаратный кошелёк (Ledger, Trezor, Coldcard). Ключи никогда не покидают устройство.

### 2. Открытый код или проверяемая прозрачность

- Отдавайте предпочтение кошелькам с открытым кодом или хотя бы с опубликованным аудитом от авторитетной фирмы (Trail of Bits, Halborn, Certik).
- Убедитесь, что компанию-разработчика можно идентифицировать. Если кошелёк создан юридическим лицом, которое можно проверить в публичном реестре (например, европейские компании в RCS, Companies House), скрыться вместе с вашими средствами ему сложнее.

### 3. Функции защиты от мошенничества (главное отличие 2026 года)

Реальный риск в 2026 году — **не** в том, что кто-то взломает ваше шифрование, а в том, что **вы сами подпишете вредоносную транзакцию**. Лучшие некастодиальные кошельки предотвращают это с помощью:

- **Сканера адресов**, который сверяет каждого получателя с известными фишинговыми и санкционными списками (GoPlus, Chainalysis, OFAC)
- **Декодера подписей**, который переводит подписи ERC-20 Permit и Permit2 на понятный язык
- **Фильтра поддельных токенов**, чтобы разосланный мошеннический scam-USDT не отображался рядом с настоящим USDT
- **Симуляции транзакции**, показывающей, что покинет ваш кошелёк, до того как вы подпишете

Читайте: [Мошенничество с вредоносным ERC-20 Permit](/en/blog/malicious-erc20-permit-scam) и [Мошенничество с отравлением адреса](/en/blog/address-poisoning-crypto-scam).

### 4. Мультичейн и одна seed-фраза

Кошелёк, поддерживающий Bitcoin, Ethereum, Solana, XRP и основные EVM-сети с одной seed-фразой BIP-39, означает меньше трудностей и меньше фраз, которые нужно защищать.

### 5. Удобство восстановления

Проверьте процесс восстановления, прежде чем загружать крупные суммы. Хороший кошелёк просит подтвердить seed-фразу при первой настройке, предупреждает, если вы пытаетесь сделать её скриншот, и содержит понятную документацию по восстановлению на новом устройстве.

## Настройка за 10 минут, которая вас защитит

1. Скачайте кошелёк со **страницы в официальном магазине приложений** (а не из рекламы в поиске — мошенники покупают спонсорские результаты)
2. Создайте новый кошелёк
3. **Запишите фразу восстановления на бумаге или металлическом носителе**. Никогда не храните её в облачной заметке, на скриншоте или в менеджере паролей с облачной синхронизацией
4. Подтвердите фразу в приложении
5. Включите биометрическую разблокировку и PIN-код
6. Сначала отправьте с биржи крошечную тестовую сумму ($5–10)
7. Убедитесь, что она дошла
8. Только после этого переводите более крупные суммы

## Некастодиальный vs. горячий/холодный: где место вашего телефона?

«Горячий» и «холодный» — **не** то же самое, что «кастодиальный» и «некастодиальный»:

- **Горячий кошелёк** = подключён к интернету (мобильное приложение, расширение браузера)
- **Холодный кошелёк** = работает офлайн (аппаратный кошелёк, бумажный кошелёк)
- Мобильный некастодиальный кошелёк — **горячий, но некастодиальный**.
- Аппаратный кошелёк — **холодный и некастодиальный**.

Для повседневного использования (<~$10k) защищённый мобильный некастодиальный кошелёк — основная рекомендация 2026 года. Для сбережений крупнее этой суммы добавьте уровень в виде аппаратного кошелька.

## Некастодиальный криптокошелёк: часто задаваемые вопросы

### Легален ли некастодиальный кошелёк?
Да. Во всех крупных юрисдикциях (США, ЕС в рамках MiCA, Великобритания, Канада, Япония, Сингапур) хранение собственных ключей законно. Обязанности по отчётности относятся к **операциям ввода/вывода фиата**, а не к самостоятельному хранению как таковому. Уточните местные правила налоговой отчётности.

### Могу ли я потерять средства с некастодиальным кошельком?
Да, тремя способами: (1) потеряв фразу восстановления, (2) подписав вредоносную транзакцию, (3) отправив средства на неверный адрес. Со всеми тремя можно справиться с помощью правильных резервных копий и кошелька с активной защитой от мошенничества.

### Является ли Coinbase Wallet некастодиальным?
Coinbase Wallet (отдельное приложение) — некастодиальный. Аккаунт на **бирже** Coinbase — кастодиальный. Это два разных продукта под одним брендом.

### Какой некастодиальный кошелёк лучше всего подходит новичкам в 2026 году?
Смотрите наше отдельное сравнение: [Лучший некастодиальный криптокошелёк 2026](/en/blog/best-non-custodial-crypto-wallet-2026). Если коротко: выбирайте мобильный кошелёк со встроенной расшифровкой подписей и сканированием адресов.

## Заключение

Некастодиальный криптокошелёк — не роскошь: в 2026 году это базовый уровень для каждого, кто держит в криптовалюте больше нескольких сотен долларов. Кривая обучения реальна, но коротка. Ключевые решения таковы: выберите кошелёк с современной защитой от мошенничества, сделайте резервную копию seed-фразы на бумаге, начните с небольшого тестового перевода и относитесь к фразе восстановления как к мастер-ключу, которым она и является.

**Готовы к самостоятельному хранению со встроенной защитой от мошенничества?** [Скачать Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380).

---

### Источники

[1] Electronic Frontier Foundation. (2026). *Self-custody as a digital-rights baseline*. [https://www.eff.org/](https://www.eff.org/)

[2] Chainalysis. (2026). *The State of Centralized Exchange Insolvencies*. [https://www.chainalysis.com/](https://www.chainalysis.com/)`
  },
  "faux-wallets-crypto-2026-7-clones": {
    title: "Поддельные криптокошельки 2026: 7 новых атак с клонами, о которых нужно знать",
    meta: "Полевое руководство 2026 года по 7 самым активным атакам с поддельными криптокошельками: клоны в магазинах приложений с рекламным продвижением, домены-двойники, «поддержка» в Telegram, модифицированные APK, дипфейк-видео основателей, фальшивые обновления MetaMask и мошенничество с восстановлением seed-фразы. С шагами по защите.",
    body: `В 2026 году атаки с поддельными криптокошельками росли быстрее любой другой категории краж в криптовалюте. По оценке Chainalysis, **только за первое полугодие 2026 года из-за схем с поддельными кошельками было потеряно $340M** [1]. Рост обусловлен профессионализацией мошеннических операций: платная поисковая реклама, инфраструктура динамического клонирования, дипфейк-видео основателей и модифицированные APK для Android с вредоносным кодом, крадущим seed-фразы.

Эта статья — полевое руководство. По каждой из 7 самых активных схем 2026 года вы узнаете, как она работает, в чём её технический трюк и какой единственный шаг её нейтрализует.

## 1. Клоны в магазинах приложений с платным продвижением

**Как это работает.** Злоумышленники публикуют в Google Play или App Store почти точную копию настоящего кошелька: та же иконка, похожее название («Lumina Wallet Pro», «MetaMask Lite», «Phantom Wallet Vault»). Затем они покупают спонсорские места в Google Search по названию бренда настоящего кошелька. Рекламный результат поднимает подделку выше оригинала.

**Технический трюк.** Поддельное приложение использует упрощённый интерфейс, похожий на настоящий кошелёк. При создании или импорте seed-фразы оно незаметно отправляет мнемоническую фразу на сервер злоумышленника. Пользователь видит стандартный экран «кошелёк готов», пока средства выводятся в фоновом режиме.

**Как это остановить.** Никогда не устанавливайте кошелёк по рекламной ссылке из поиска. Переходите сразу на официальный домен производителя (вводите его вручную, а не через поиск), находите там значок магазина и переходите по нему. Google официально рекомендует такой порядок для криптоприложений [2]. См. также: [Поддельные клоны криптокошельков](/en/blog/fake-crypto-wallet-clones).

## 2. Домены-двойники (Punycode и тайпосквоттинг)

**Как это работает.** Злоумышленники регистрируют домены, визуально неотличимые от настоящих: «luminawallet.com» и «lumınawallet.org» (i без точки), «metamask.io» и «metamαsk.io» (греческая альфа), «trustwallet.com» и «trust-wallet.com».

**Технический трюк.** Адресная строка браузера отображает символы Unicode, неотличимые от латинских букв (IDN-гомографическая атака). Многие пользователи кошельков этого не замечают.

**Как это остановить.** Всегда используйте закладку для веб-страницы кошелька. Никогда не вводите домен в спешке. Менеджеры паролей, сопоставляющие точный домен, откажутся автозаполнять данные на домене-двойнике — это сигнал остановиться.

## 3. Мошенничество с «поддержкой в Telegram»

**Как это работает.** Вы пишете жалобу в легитимной криптогруппе («Моя транзакция зависла»). Через несколько минут вам в личные сообщения пишет аккаунт с именем «Lumina Wallet Support» или «MetaMask Help» и предлагает помощь. Он присылает ссылку на «панель поддержки» и просит подключить кошелёк или вставить seed-фразу, чтобы «подтвердить владение».

**Технический трюк.** Ни одна настоящая компания-разработчик кошелька не ведёт поддержку в Telegram таким образом. Мошенники используют боты-скраперы, которые находят упоминания брендов кошельков и за считаные секунды отправляют личные сообщения.

**Как это остановить.** Ни одна легитимная служба поддержки кошелька никогда не попросит вашу seed-фразу, приватный ключ или подключение к неизвестному dApp. Все настоящие каналы поддержки доступны из официального приложения, а не наоборот. См. [Мошенничество с поддельной поддержкой и «восстановлением» криптовалюты](/en/blog/fake-support-crypto-recovery-scams).

## 4. Модифицированные APK для Android (атаки через сторонние установки)

**Как это работает.** Пользователь Android ищет «download MetaMask APK» и устанавливает модифицированную версию со стороннего сайта. Такое приложение выглядит и работает как настоящее, но содержит код, перехватывающий генерацию seed-фразы.

**Технический трюк.** Злоумышленник берёт настоящий APK с открытым исходным кодом, внедряет вредоносный код в процесс генерации ключей (так что энтропия частично контролируется атакующим), заново подписывает файл и распространяет его на сайтах-зеркалах APK.

**Как это остановить.** На Android устанавливайте кошельки только из Google Play Store. По умолчанию держите отключённой опцию «Установка из неизвестных источников». Пользователей iPhone естественным образом защищает песочница App Store.

## 5. Дипфейк-видео основателей (мошенничество с раздачами)

**Как это работает.** Реклама на YouTube и TikTok показывает «Виталика Бутерина», «Чанпэна Чжао» или настоящего основателя кошелька, объявляющего «раздачу в честь обновления кошелька». Отправьте 1 ETH на QR-код — получите обратно 2 ETH. Видео является дипфейком.

**Технический трюк.** Открытые модели 2026 года (SadTalker-v4, HeyGen-OSS, клоны VASA-1) способны по одной фотографии и образцу клонированного голоса генерировать убедительные видео с синхронизацией губ. Аналитическая команда Lumina обнаружила 23 разных дипфейк-видео, имитирующих основателей крупных кошельков, только в третьем квартале 2026 года.

**Как это остановить.** Ни один легитимный кошелёк никогда не проводит акций вида «отправь X — получи 2X». Никогда. Это стопроцентно надёжный признак мошенничества. Кроме того, прямые трансляции с основателями проще проверить на подлинность, чем заранее записанные видео.

## 6. Фальшивые всплывающие окна «обновление кошелька» в браузере

**Как это работает.** Вы заходите на любой криптосайт. Всплывающее окно или внедрённый баннер сообщает: «Ваш MetaMask устарел. Нажмите, чтобы обновить». Ссылка ведёт на страницу, которая устанавливает вредоносное расширение браузера или модифицированный кошелёк.

**Технический трюк.** Многие такие окна приходят из скомпрометированных сторонних рекламных сетей на легитимных криптосайтах. Настоящий кошелёк никогда не показывает запросы на обновление подобным образом: расширения браузера обновляются через магазин Chrome / Firefox, мобильные приложения — через магазин ОС.

**Как это остановить.** Игнорируйте любые запросы «обновите свой кошелёк» на веб-страницах. Проверяйте обновления только в магазине расширений браузера или в магазине приложений на телефоне. Если запрос настойчив, закройте вкладку.

## 7. Мошенничество с «миграцией» и повторным вводом seed-фразы

**Как это работает.** Вы получаете письмо, SMS или сообщение в приложении: «Ваш кошелёк переносится на новую защищённую версию. Пожалуйста, введите seed-фразу заново на этой странице, чтобы перенести ваши активы». Оформление копирует бренд вашего настоящего кошелька.

**Технический трюк.** Схема использует то, что настоящие кошельки действительно иногда проводят ребрендинг или миграцию. Злоумышленники имитируют такие легитимные события (иногда в течение 48 часов после настоящего объявления компании), чтобы снизить бдительность пользователей.

**Как это остановить.** Никакая миграция кошелька не требует повторного ввода seed-фразы на веб-странице или в форме. Настоящие миграции либо проходят внутри приложения, либо сводятся к обычному обновлению из магазина. Если сомневаетесь, откройте официальное приложение напрямую и поищите объявление внутри него.

## Краткая справка: признаки поддельных кошельков в 2026 году

| Тревожный признак | Что происходит |
|---|---|
| «Введите seed-фразу для проверки / восстановления / миграции» | Фишинг. Всегда. |
| Спонсорский результат Google по названию бренда кошелька | Вероятно, клон. Пролистайте дальше. |
| Загрузка APK с сайта, не являющегося Play Store | Модифицированное вредоносное ПО. |
| Личное сообщение от «поддержки кошелька» после публичной жалобы | Бот-скрапер. Пожаловаться и заблокировать. |
| «Отправь X, получи 2X» от имени основателя | Дипфейк / фальшивая раздача. |
| Всплывающее окно на странице с просьбой обновить кошелёк | Внедрённая реклама. Игнорировать. |
| Менеджер паролей отказывается автозаполнять данные на домене «кошелька» | Домен-двойник. Остановитесь. |

## Как Lumina Wallet защищает от схем с поддельными кошельками

Lumina Wallet объединяет практические средства защиты, описанные в этом руководстве:

- **Проверка источника установки** — на экране первого запуска отображается целостность пакета приложения, поэтому модифицированный APK можно обнаружить
- **Расшифровка подписей** — вредоносные транзакции от клонов dApp помечаются понятным языком ещё до подписания
- **Сканер адресов** — адреса получателей сверяются с известными базами фишинга и санкционных списков
- **Предупреждение о видимости seed-фразы** — приложение обнаруживает попытки сделать скриншот экрана с seed-фразой и блокирует их на Android

Подробный разбор: [подход Lumina к безопасности](/en/security).

## Часто задаваемые вопросы о поддельных кошельках

### Может ли поддельный кошелёк украсть мои средства только потому, что я его установил?
Не сразу. Большинство поддельных кошельков крадут средства, когда вы (а) импортируете в них существующую seed-фразу, (б) создаёте в них новую seed-фразу или (в) подписываете созданную ими транзакцию. Если установить такой кошелёк и никогда им не пользоваться, риск относительно невелик, но всё равно удалите его.

### Как проверить, что мой текущий кошелёк настоящий?
На Android проверьте источник установки: Настройки → Приложения → [Кошелёк] → О приложении → Установщик. Там должно быть указано «Google Play Store» (com.android.vending). На iOS приложения, установленные из настоящего App Store, нельзя модифицировать таким образом, поэтому риск ниже. Также сравните имя издателя с доменом настоящего производителя.

### Кажется, я ввёл seed-фразу на фейковом сайте. Что делать?
Немедленно: откройте свой легитимный кошелёк и переведите все токены на совершенно новый кошелёк, который вы создадите (с новой seed-фразой). Старая seed-фраза скомпрометирована навсегда. См. [Мошенничество с поддельной поддержкой и «восстановлением» криптовалюты](/en/blog/fake-support-crypto-recovery-scams).

### Защищены ли аппаратные кошельки от этих атак?
В основном да. Аппаратные кошельки защищают ключ, поэтому даже поддельное сопутствующее приложение на телефоне не сможет его извлечь. Однако вредоносная транзакция, созданная поддельным dApp, всё равно отобразится на аппаратном кошельке, и вам по-прежнему нужно не подтверждать её. Читайте экран устройства.

## Заключение

Поддельные криптокошельки в 2026 году — это не любительские операции, а профессиональные, хорошо финансируемые схемы, которые быстро совершенствуются. Защита скучна, но надёжна: устанавливайте приложения только из официальных магазинов, никогда не вводите seed-фразу вне приложения, которое её сгенерировало, используйте кошелёк с расшифровкой подписей и сохраняйте настоящие домены в закладки. Четыре привычки, ноль исключений.

**Установите Lumina Wallet — только из официальных магазинов:** [Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380).

---

### Источники

[1] Chainalysis. (2026). *Mid-Year Crypto Crime Report 2026 — Fake Wallet Threats*. [https://www.chainalysis.com/](https://www.chainalysis.com/)

[2] Google Safety. (2026). *Crypto Wallet App Safety Guidelines*. [https://safety.google/](https://safety.google/)`
  },
  "checklist-securite-wallet-crypto-2026": {
    title: "Чек-лист безопасности криптокошелька на 2026 год",
    meta: "Практичный чек-лист безопасности без преувеличений для любого пользователя криптокошелька в 2026 году. Пятнадцать пунктов, сгруппированных по этапам: настройка, повседневное использование, долгосрочное хранение и восстановление. Написан для обычных пользователей, а не для аудиторов.",
    body: `Большинство статей с «советами по безопасности» криптокошельков либо слишком технические (модели угроз для аудиторов), либо слишком расплывчатые («будьте осторожны!»). Это список другого рода: **пятнадцать конкретных проверяемых действий**, сгруппированных по этапам вашего пути в крипте, с указанием атаки, которую блокирует каждое из них. Если в этом году вы прочтёте лишь один список по безопасности кошельков, именно этот стоит распечатать.

## Раздел 1 — Настройка (первые 15 минут)

### 1. Устанавливайте из официального магазина, а не по рекламе в поиске
**Блокирует:** клоны с проплаченных размещений в магазине и модифицированные APK.
Введите настоящий домен разработчика вручную, найдите там значок магазина и перейдите по нему. Никогда не устанавливайте приложение из спонсорской выдачи Google.

### 2. Проверьте название издателя на странице приложения
**Блокирует:** приложения-двойники с похожими иконками.
В Google Play и App Store название издателя отображается под названием приложения. Оно должно совпадать с компанией, которую вы ожидаете увидеть (например, «HEDONISME SARL» для Lumina Wallet). Если указано «Lumina Studios LLC» — это клон.

### 3. Создайте новый кошелёк — не импортируйте старый на новый телефон сразу
**Блокирует:** ситуации со скомпрометированной сид-фразой.
Если вы настраиваете кошелёк впервые, сгенерируйте новую сид-фразу. Импортируйте существующую, только если вам действительно нужен доступ к этим средствам.

### 4. Запишите сид-фразу на бумагу или металлический носитель
**Блокирует:** утечки из облака и вредоносные программы, делающие скриншоты.
Никогда не храните сид-фразу в облачной заметке (Google Keep, iCloud Notes, Dropbox), в виде скриншота, в менеджере паролей с облачной синхронизацией или в черновиках почты. Только бумага или стальная пластина (Billfodl, Cryptosteel).

### 5. Подтвердите сид-фразу в приложении и проверьте восстановление до пополнения кошелька
**Блокирует:** опечатки при настройке, которые обнаруживаются слишком поздно.
Большинство кошельков просят подтвердить сид-фразу, повторно выбрав слова. Делайте это внимательно. Затем, прежде чем переводить реальные деньги, удалите кошелёк и один раз восстановите его по письменной резервной копии. Если восстановление прошло успешно, ваша копия рабочая.

## Раздел 2 — Повседневное использование

### 6. Защитите приложение биометрией и PIN-кодом
**Блокирует:** кражу телефона в разблокированном состоянии.
Важны оба уровня: биометрия для ежедневного удобства, PIN-код как запасной вариант, если вор подберёт нужный угол для распознавания лица.

### 7. Используйте кошелёк с расшифровкой подписей
**Блокирует:** вредоносные подписи ERC-20 Permit и Permit2.
Хороший кошелёк переводит подпись на понятный язык («Вы разрешаете [неизвестному контракту] потратить НЕОГРАНИЧЕННОЕ количество USDT») до того, как вы её поставите. Если ваш кошелёк показывает «сырой» hex, перейдите на другой. Подробнее читайте в нашем разборе [вредоносных мошеннических схем с ERC-20 Permit](/en/blog/malicious-erc20-permit-scam).

### 8. Включите фильтрацию поддельных токенов (или пользуйтесь кошельком, где она включена по умолчанию)
**Блокирует:** мошенничество с эйрдропами, когда рядом с настоящим USDT появляется поддельный.
Lumina Wallet фильтрует токены по официальному адресу контракта. Если ваш кошелёк показывает все эйрдропы, считайте каждый неожиданный токен подозрительным, пока его подлинность не подтверждена в блокчейн-эксплорере.

### 9. Проверяйте адрес получателя с помощью ончейн-сканера
**Блокирует:** отравление адресов и адреса под санкциями.
Современные кошельки в реальном времени сверяют каждый адрес назначения со списками GoPlus, Chainalysis и OFAC. Если адрес помечен — остановитесь. Читайте: [мошенничество с отравлением адресов](/en/blog/address-poisoning-crypto-scam).

### 10. Сначала проверьте нового получателя небольшой суммой
**Блокирует:** опечатки, отравление адресов, подмену скопированных адресов фишинговыми.
Перед любым переводом свыше ~$500 сначала отправьте ~$5–10. Убедитесь, что они пришли на нужный кошелёк. Затем отправляйте остальное.

## Раздел 3 — Транзакции и dApp

### 11. Никогда не подписывайте то, чего не понимаете
**Блокирует:** все сливы средств через подписи (Permit, Permit2, SeaportOrder, разрешения ERC-721).
Если кошелёк или dApp показывает запрос на подпись с непонятными полями, не подписывайте. В 2026 году **нет ни одной законной причины** подписывать непрозрачную подпись.

### 12. Считайте «Approve unlimited» тревожным сигналом
**Блокирует:** разрешения на неограниченные траты, которые остаются активными навсегда.
Когда dApp запрашивает разрешение на токен ERC-20, выбирайте «custom amount» (только сумма этой транзакции), а не «unlimited». Периодически просматривайте и отзывайте старые неограниченные разрешения через Revoke.cash или менеджер разрешений вашего кошелька.

### 13. Отключайте dApp, которыми больше не пользуетесь
**Блокирует:** эксплуатацию «спящих» разрешений в будущем.
В каждом кошельке есть раздел «подключённые сайты» или «подключённые приложения». Если вы не узнаёте подключение, отключите его. Ежемесячная проверка занимает 30 секунд.

## Раздел 4 — Долгосрочное хранение и восстановление

### 14. Используйте аппаратный кошелёк для сумм выше вашей «границы комфорта»
**Блокирует:** вредоносное ПО на устройстве, которое выкачивает ключи.
У каждого свой порог, после которого «я бы очень расстроился, если бы это украли». Для большинства пользователей в 2026 году эта граница лежит где-то между $5 тыс. и $20 тыс. Выше неё аппаратный кошелёк за ~$70–$150 того стоит.

### 15. Разделите средства как минимум между двумя кошельками
**Блокирует:** компрометацию единственного кошелька, при которой теряется всё.
Разделите «кошелёк для трат» (мобильный, удобный, небольшие суммы) и «кошелёк для накоплений» (аппаратный или программный кошелёк с надёжными резервными копиями, холодный). Переводы между ними редки и осознанны.

## Сводка для печати

| # | Действие | Блокирует |
|---|---|---|
| 1 | Установка из официального магазина | Клоны в магазинах |
| 2 | Проверка названия издателя | Приложения-двойники |
| 3 | Создание нового кошелька | Скомпрометированные сид-фразы |
| 4 | Резервная копия на бумаге/металле | Утечки из облака |
| 5 | Проверка восстановления до пополнения | Опечатки при настройке |
| 6 | Биометрия + PIN-код | Кража телефона |
| 7 | Расшифровка подписей | Сливы через Permit/Permit2 |
| 8 | Фильтр поддельных токенов | Мошенничество с эйрдропами |
| 9 | Ончейн-сканер адресов | Отравление адресов |
| 10 | Небольшой тестовый перевод | Опечатки, отравление |
| 11 | Не подписывать непрозрачные подписи | Все мошенничества с подписями |
| 12 | Избегать неограниченных разрешений | Сливы через бессрочные разрешения |
| 13 | Отключать неиспользуемые dApp | «Спящие» эксплойты |
| 14 | Аппаратный кошелёк для накоплений | Вредоносное ПО на устройстве |
| 15 | Разделение трат и накоплений | Компрометация единственного кошелька |

## Как Lumina Wallet закрывает пункты этого чек-листа

Пункты 6–11 и 13 встроены в Lumina Wallet по умолчанию — настройка не требуется. Пункты 1–5, 12, 14 и 15 зависят от ваших личных привычек, и ни один кошелёк не может обеспечить их выполнение за вас.

Полный обзор возможностей: [возможности Lumina Wallet](/en/features) и [подход к безопасности](/en/security).

## FAQ по безопасности криптокошелька

### Как часто нужно пересматривать этот чек-лист?
Полностью перечитывать его достаточно раз в 6 месяцев. Быстрые пункты (3, 9, 13) стоит выполнять перед каждой новой транзакцией свыше $500.

### Безопасно ли хранить сид-фразу в менеджере паролей?
Только если в менеджере паролей вообще нет облачной синхронизации (только локальное хранилище), а устройство зашифровано. Для большинства пользователей бумага или металл проще и надёжнее. Менеджеры паролей с облачной синхронизацией — это облако, а значит, для хранения сид-фразы они не подходят.

### Что делать, если телефон украли с разблокированным кошельком?
Если у вас были выполнены пункты 6 (биометрия + PIN-код) и 15 (разделение средств), риск для кошелька трат ограничен, а накопления остались нетронутыми. Тем не менее немедленно отзовите подключения dApp с другого устройства, а если у вас есть сид-фраза, переведите средства на новый кошелёк.

### Остаётся ли безопасной криптоактивность в браузере в 2026 году?
Может, при условии репутационного расширения-кошелька, отдельного профиля браузера и строгой проверки подписей. Но поверхность атаки больше, чем на мобильных устройствах. Для большинства обычных пользователей мобильные кошельки со встроенной защитой — более удачный выбор по умолчанию в 2026 году.

## Заключение

Безопасность криптокошелька в 2026 году на 90 % состоит из привычек и на 10 % из технологий. Технологическая часть важна: кошелёк с расшифровкой подписей, сканированием адресов и фильтрацией поддельных токенов закрывает атаки, которые никакая дисциплина не остановит в одиночку. Но именно пятнадцать описанных привычек отличают пользователя, который спокойно спит по ночам, от того, кто узнаёт о гигиене сид-фразы на горьком опыте.

**Попробуйте кошелёк со встроенными пунктами 6–11 и 13:** [Lumina Wallet в Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380).

---

### Источники

[1] NIST. (2026). *Digital Identity Guidelines — Cryptographic Key Management for Consumer Wallets*. [https://www.nist.gov/](https://www.nist.gov/)

[2] GoPlus Labs. (2026). *2026 Crypto Threat Intelligence Report*. [https://gopluslabs.io/](https://gopluslabs.io/)`
  },
  "verifier-app-wallet-crypto-authentique": {
    title: "Как проверить, настоящее ли приложение криптокошелька: чек-лист проверки на 2026 год",
    meta: "Прежде чем устанавливать приложение криптокошелька, выполните эти проверки: официальная ссылка, издатель, идентификатор приложения, разрешения и поведение seed-фразы. Чек-лист на 5 минут, который поможет распознать поддельные приложения кошельков.",
    body: `Поддельные приложения кошельков — один из самых простых способов потерять криптовалюту: вы устанавливаете то, что выглядит как обычный кошелёк, создаёте или импортируете фразу восстановления, а приложение незаметно отправляет эту фразу мошеннику. Никакого взлома, никаких уязвимостей — просто не то приложение.

Хорошая новость: большинство поддельных приложений кошельков не проходят несколько базовых проверок. В этом руководстве — **порядок проверки, который можно выполнить примерно за пять минут** перед установкой любого кошелька, включая Lumina Wallet.

> Уже знакомы с основными признаками подделок? В нашем руководстве [Поддельные криптокошельки: как распознать клоны](/ru/blog/faux-wallets-crypto-clones) объясняется, как работают приложения-клоны. Эта статья — практический чек-лист.

## Шаг 1. Начинайте с официального сайта, а не с рекламы в поиске

Самая частая точка входа для поддельного кошелька — **спонсорский результат** или реклама, которая отображается выше настоящего сайта. Мошенники покупают рекламу по названиям кошельков, потому что люди ищут их именно так.

- Введите адрес официального сайта самостоятельно или воспользуйтесь закладкой, которую создали ранее.
- Используйте ссылки для скачивания, опубликованные на этом сайте, а не первую ссылку в поисковике или социальной сети.
- Остерегайтесь доменов-двойников: лишняя буква, другое расширение (.app, .io, .net) или визуально одинаковые символы (например, «rn» вместо «m»).

Официальные ссылки для скачивания Lumina Wallet перечислены на [странице загрузки](/ru/download).

## Шаг 2. Проверьте издателя на странице в магазине

В App Store или Google Play откройте страницу приложения и посмотрите на **имя разработчика / издателя**, а не только на название и логотип — их легко скопировать.

- Издатель должен совпадать с компанией или проектом, стоящим за официальным сайтом.
- Нажмите на имя издателя: у настоящей команды кошелька обычно последовательная история, а не список не связанных между собой приложений, опубликованных на прошлой неделе.
- Прочитайте самые свежие отзывы. Несколько отзывов о том, что «средства пропали после импорта», — серьёзный тревожный признак. Ещё один — множество однотипных отзывов на пять звёзд, оставленных за несколько дней.

## Шаг 3. Сравните идентификатор приложения

У каждого приложения есть уникальный идентификатор, который клон не сможет повторно использовать в официальных магазинах:

- **Android:** имя пакета в URL Google Play (после \`id=\`).
- **iOS:** числовой ID в URL App Store (после \`/id\`).

Сравните его с идентификатором в ссылке с официального сайта. Если сайт ведёт на один ID, а найденное вами приложение имеет другой, это не то же самое приложение.

## Шаг 4. Никогда не устанавливайте кошелёк из присланного вам файла

Кошелёк, установленный из APK-файла, которым поделились в Telegram, Discord, WhatsApp или по электронной почте, полностью обходит проверку магазином. «Модифицированные», «pro» или «разблокированные» версии кошелька — классическая ловушка.

- Устанавливайте кошельки только из официальных магазинов по ссылкам с официального сайта.
- Если кто-то настаивает, что вам нужно установить особую версию, чтобы «исправить вашу учётную запись», считайте это мошенничеством. Эту схему мы разбираем в статье о [поддельной поддержке и мошенничестве с «восстановлением» средств](/ru/blog/faux-support-arnaques-recuperation-crypto).

## Шаг 5. Посмотрите разрешения (Android)

Приложению кошелька нужно совсем немногое: доступ к сети и иногда к камере для сканирования QR-кодов. Насторожитесь, если кошелёк запрашивает:

- **Службы специальных возможностей** (могут считывать содержимое экрана и управлять им),
- **Отображение поверх других приложений** (могут показывать поддельные экраны поверх настоящих),
- **Доступ к SMS** или права **администратора устройства**.

Ничто из этого не требуется для отправки или получения криптовалюты.

## Шаг 6. Следите за тем, как приложение обращается с вашей фразой восстановления

Это самая важная проверка, ведь именно фраза восстановления нужна мошеннику.

- Настоящий некастодиальный кошелёк **генерирует** фразу восстановления на вашем устройстве при создании нового кошелька. Он просит записать её офлайн.
- Он никогда не просит отправить фразу в «поддержку», «подтвердить» или «синхронизировать» её на сайте либо ввести её, чтобы «разблокировать» награду.
- Если приложение сразу требует импортировать существующую фразу и давит на вас («ваш кошелёк будет заблокирован»), остановитесь.

Если есть сомнения, **создайте новый кошелёк** в приложении, а не импортируйте основную фразу восстановления, и сначала протестируйте его.

## Шаг 7. Протестируйте на небольшой сумме

Прежде чем переводить значительные средства:

1. Отправьте небольшую сумму на новый кошелёк.
2. Проверьте транзакцию в публичном обозревателе блоков.
3. Отправьте часть обратно на адрес, который вы контролируете.

Если что-то работает странно — баланс не отображается, адрес неожиданно меняется, требуется «комиссия» для разблокировки средств, — прекратите пользоваться приложением.

## Чек-лист на 5 минут

| Проверка | Как выглядит настоящее приложение |
| --- | --- |
| Источник | Ссылка взята с официального сайта, а не из рекламы или сообщения |
| Издатель | Тот же субъект, что и на официальном сайте, последовательная история |
| Идентификатор приложения | Совпадает с ID в ссылке с официального сайта |
| Установка | Только из официального магазина, никогда — из присланного APK-файла |
| Разрешения | Нет прав специальных возможностей, наложения, SMS или администратора |
| Фраза восстановления | Генерируется локально, «поддержка» или сайт её никогда не запрашивают |
| Первое использование | Небольшая тестовая транзакция перед переводом крупных сумм |

## Что делать, если вы установили поддельный кошелёк

Если вы ввели фразу восстановления в приложение, в котором теперь сомневаетесь, считайте, что фраза скомпрометирована:

1. **Действуйте быстро.** Установите настоящий кошелёк из официального источника на надёжное устройство и создайте **новый** кошелёк с новой фразой восстановления.
2. **Переведите средства** со старых адресов на новый кошелёк.
3. **Проверьте разрешения (approvals) токенов**, связанные со старыми адресами, с помощью надёжного инструмента для проверки разрешений и отзовите те, которые вы не узнаёте.
4. **Удалите поддельное приложение** и сообщите о нём в магазин.
5. **Игнорируйте всех, кто предлагает вернуть ваши средства** за плату: такие предложения почти всегда оказываются вторым мошенничеством.

## FAQ

**Может ли поддельное приложение кошелька находиться в официальных магазинах?**
Да, такое случается: некоторые клоны какое-то время проходят проверку, прежде чем их удаляют. Поэтому важно проверять издателя и идентификатор приложения, а не только сам магазин.

**Всегда ли кошелёк с большим числом загрузок настоящий?**
Нет. Число загрузок и отзывы можно накрутить. Используйте их как один из признаков среди прочих, но никогда как доказательство.

**Просит ли Lumina Wallet мою фразу восстановления?**
Нет. Lumina Wallet — некастодиальный кошелёк: ваша фраза восстановления остаётся на вашем устройстве, и никто из Lumina не попросит её у вас.

**Как обезопасить кошелёк после установки?**
Следуйте нашему [Чек-листу безопасности криптокошелька на 2026 год](/ru/blog/checklist-securite-wallet-crypto-2026) — в нём описаны настройка, повседневное использование и восстановление.

## Заключение

Поддельное приложение кошелька срабатывает только в том случае, если вы пропускаете базовые проверки. Берите ссылку с официального сайта, сравнивайте издателя и идентификатор приложения, отказывайтесь от файлов, присланных посторонними, и никому не передавайте фразу восстановления. Пять минут проверки обходятся гораздо дешевле потерянного кошелька.

Чтобы установить Lumina Wallet, используйте ссылки на официальной [странице загрузки](/ru/download).`
  },
  "crypto-volees-que-faire": {
    title: "Возврат криптовалюты после мошенничества в Ethereum: что реально можно сделать после кражи (2026)",
    meta: "У вас украли криптовалюту? Что реально можно сделать в первые 24 часа: защитить кошелёк, сохранить доказательства, отследить средства, обратиться в полицию, на биржи и к эмитентам стейблкоинов, а также не попасться на мошенников, обещающих возврат.",
    body: `Если ваши ETH или токены украли с помощью мошенничества, фишингового сайта или вредоносной подписи, самое важное — первые часы. В этом руководстве объясняется, **что реально можно сделать**, в каком порядке, и как не потерять ещё больше денег из-за «экспертов по возврату», которые охотятся на жертв сразу после кражи.

Сначала честно скажем главное: транзакции в блокчейне нельзя отменить. Никто — ни ваш кошелёк, ни Ethereum, ни Lumina Wallet — не может нажать кнопку и откатить их. Вернуть средства иногда удаётся, но только определёнными путями: биржа или эмитент стейблкоина замораживает средства, как правило, после официального обращения.

## Шаг 1: остановите ущерб (первые минуты)

Прежде чем пытаться что-либо вернуть, защитите то, что осталось.

- **Не отправляйте больше денег** никому, кто обещает «разблокировать», «освободить» или «вернуть» ваши средства.
- Если ваша **фраза восстановления** могла быть скомпрометирована (вы ввели её на сайте, в приложении, к которому теперь есть сомнения, или передали «поддержке»), создайте **новый кошелёк с новой фразой восстановления** на надёжном устройстве и переведите туда оставшиеся средства.
- Если кража произошла из-за **вредоносного разрешения (approval) или подписи**, проверьте разрешения токенов для вашего адреса с помощью надёжного сервиса проверки (например, инструмента Token Approvals на Etherscan) и отзовите те, которые вы не узнаёте. Дрейнер может пользоваться разрешением, пока оно не отозвано.
- Отключите кошелёк от сайта, с которым была связана кража, и удалите все подозрительные приложения и расширения браузера.

## Шаг 2: соберите доказательства

Все дальнейшие шаги зависят от точной информации. Запишите или сохраните:

- **хеши транзакций** (TxID) украденных переводов;
- ваш адрес и **адреса получателей**;
- дату, время и суммы;
- URL сайта, название приложения, профили в социальных сетях и имена пользователей, связанные с кражей;
- скриншоты переписки, рекламы, писем и страниц, которыми вы пользовались.

Сохраните оригиналы сообщений: не удаляйте чат с мошенником.

## Шаг 3: проследите движение средств в обозревателе блоков

Вставьте хеш транзакции в обозреватель блоков, например Etherscan. Посмотрите, куда средства ушли дальше:

- Если они ушли на адрес с пометкой **централизованная биржа** (депозитный адрес известной платформы), это самая полезная зацепка: регулируемые биржи могут заморозить аккаунт, как правило, по запросу полиции.
- Если украдены **USDT или USDC**, их эмитенты технически способны заморозить токены на адресе, обычно во взаимодействии с правоохранительными органами. Важна скорость, потому что мошенники часто быстро обменивают такие токены.
- Если средства прошли через **миксер** или множество промежуточных адресов, вернуть их гораздо сложнее. Всё равно сообщите о случившемся.

Быть экспертом не нужно: хеши транзакций и адреса получателей — это то, что запросят следователи и биржи.

## Шаг 4: подайте официальное заявление

Именно официальное заявление делает заморозку возможной. Подайте его как можно скорее:

- **В полицию** вашей страны или в службу приёма заявлений о киберпреступлениях (в США — IC3 ФБР на ic3.gov). Попросите номер заявления или справку с реквизитами обращения.
- **На биржу**, получившую средства: свяжитесь с её официальной поддержкой через сайт или приложение (ни в коем случае не по ссылке, которую вам прислали), приложив хеши транзакций и номер обращения в полицию.
- **Эмитенту стейблкоина**, если украдены USDT или USDC, — через его официальный сайт.
- **В публичные базы данных мошенничества**, такие как Chainabuse, чтобы предупредить других пользователей о связанных адресах.
- **На платформу, где вы познакомились с мошенником** (социальная сеть, магазин приложений, рекламная сеть), чтобы аккаунт, приложение или объявление удалили.

## Шаг 5: остерегайтесь «экспертов по возврату»

Сразу после кражи жертвам часто пишут люди, которые утверждают, что могут «взломать в ответ», «отследить и вернуть» или «разблокировать» украденную криптовалюту за предоплату. На практике такие предложения — хорошо известное повторное мошенничество.

Тревожные признаки:

- они сами выходят на связь, часто в комментариях или личных сообщениях после вашей публикации о краже;
- они гарантируют результат или называют точный процент успеха;
- они просят предоплату, «налог», «газ» или «плату за разблокировку»;
- они просят вашу фразу восстановления или удалённый доступ к вашему устройству.

Настоящие правоохранительные органы никогда не берут с вас деньги за возврат средств. Если вам нужна профессиональная помощь, выбирайте лицензированного юриста или известную компанию по блокчейн-расследованиям, личность которой можно проверить, и никогда не платите незнакомцу, который сам к вам обратился. В нашей статье о [мошенничестве с «возвратом» криптовалюты и фальшивой поддержке](/ru/blog/faux-support-arnaques-recuperation-crypto) такие схемы описаны подробно.

## Первые 24 часа: коротко

| Когда | Что делать |
| --- | --- |
| Первые минуты | Прекратите платить кому-либо, защитите оставшиеся средства, отзовите подозрительные разрешения |
| Первый час | Сохраните хеши транзакций, адреса, URL и скриншоты |
| Первые часы | Отследите средства в обозревателе блоков, определите биржи или стейблкоины |
| В тот же день | Подайте заявление в полицию, свяжитесь с биржей и эмитентом через официальные каналы |
| Следующие дни | Публично сообщите об адресах, игнорируйте незапрошенные предложения «вернуть» средства |

## Каковы шансы вернуть криптовалюту?

Честно говоря, они ограничены и зависят от маршрута, по которому прошли средства. Случаи, когда средства замораживают или возвращают, обычно объединяют три условия: жертва отреагировала быстро, средства попали на регулируемую биржу или в стейблкоин, который можно заморозить, и было подано официальное заявление. Если не выполняется ни одно из них, вернуть средства удаётся редко.

Поэтому профилактика так важна: после подписания вредоносной транзакции кнопки «отменить» нет.

## Как избежать этого в будущем

- Проверяйте, что вы подписываете: большинство кражи начинаются с разрешения (approval), permit или транзакции, которую вы до конца не поняли. Lumina Wallet анализирует транзакции перед подписанием и предупреждает об известных рисках, но ни один инструмент не поймает всё — и ни один кошелёк не может отменить транзакцию после её подтверждения.
- Устанавливайте кошельки только из официальных источников: см. [как проверить, настоящее ли приложение криптокошелька](/ru/blog/verifier-app-wallet-crypto-authentique).
- Следуйте [чек-листу безопасности криптокошелька](/ru/blog/checklist-securite-wallet-crypto-2026), чтобы разделить сбережения и повседневный кошелёк.

## FAQ

**Можно ли отменить украденную транзакцию в Ethereum?**
Нет. Подтверждённые транзакции окончательны. Единственные реалистичные пути — заморозка биржей или эмитентом стейблкоина, как правило, после официального заявления.

**Стоит ли платить сервису, который обещает вернуть мою криптовалюту?**
Будьте предельно осторожны. Незапрошенные предложения с предоплатой или гарантированным результатом — известная мошенническая схема. Настоящие расследования проводятся через полицию, задействованную биржу или проверенного лицензированного специалиста.

**Стоит ли сообщать о краже, если сумма небольшая?**
Да. Заявления помогают следователям связывать дела между собой, а публичные сообщения в базах данных мошенничества предупреждают других пользователей о тех же адресах.

**Может ли Lumina Wallet вернуть мои украденные средства?**
Нет. Lumina Wallet является некастодиальным и не может отменить или заморозить транзакции. Он может помочь вам защитить новый кошелёк и проверять будущие транзакции перед подписанием.

## Заключение

После кражи криптовалюты: защитите то, что осталось, сохраните доказательства, отследите средства, обратитесь по официальным каналам и откажитесь от любых платных предложений «вернуть» деньги. Скорость и официальные заявления дают вам наилучшие шансы — и ничего не стоят.`
  }
};

export default ru;
